import { HttpBackend, HttpClient, HttpContext, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {Injectable, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {BehaviorSubject, forkJoin, from, Observable, of, throwError, timer} from 'rxjs';
import {API_PATH, CartTypes, Classes, QuestionType, RouterLinks, Superflow} from '../constants';
import {SILENT_ERROR} from '../http/silent-error.token';
import {FlowItem, Question, ShoppingCartItem} from '../models/underwriter.model';
import {QuestionFlowSessionQuery} from '../questions/state/question-flow-session.query';
import {QuestionQuery} from '../questions/state/question.query';
import {QuestionStore} from '../questions/state/question.store';
import {FlowPlayerService} from './flow-player.service';
import {catchError, map, mergeMap, switchMap, takeWhile, tap, timeout} from 'rxjs/operators';
import {QuoteCollation} from '../models/quote.model';
import {QuestionFlowSessionStore} from '../questions/state/question-flow-session.store';
import {ItemsQuery} from '../questions/state/items.query';
import {ItemsStore} from '../questions/state/items.store';
import {SuperflowStore} from '../questions/state/superflow.store';
import {SuperflowQuery} from '../questions/state/superflow.query';
import {UserStore} from '../../authentication/state/user.store';
import {ShoppingCartStore} from '../questions/state/shopping-cart-store';
import {ShoppingCartQuery} from '../questions/state/shopping-cart-query';
import {Industry} from '../models/Industry';
import {Profession} from '../models/Profession';
import {VehicleMake, VehicleModel, VehicleYear} from '../models/VehicleDetails';
import {Router} from '@angular/router';
import {QuoteCategory} from '../../quotes/models/quote.model';
import {MiniQuestionFlowSessionQuery} from '../questions/state/mini-question-flow-session.query';
import {MiniQuestionStore} from '../questions/state/mini-question.store';
import {MiniQuestionQuery} from '../questions/state/mini-question.query';
import {MiniFlowPlayerService} from './mini-flow-player-service';
import {PageInfo} from '../models/page-info';
import {TpqStatusCheck} from '../../quotes/models/tpq-status-check';
import {environment} from '../../../../environments/environment';
import {QuestionTrafficCopComponent} from '../shared.module';
import {Browser} from '@capacitor/browser';
import {Alert} from '../utilities';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {StorageService} from './storage.service';

declare var $: any;
declare var accounting: any;

const headers = new HttpHeaders()
  .set('content-type', 'application/json')
  .set('Access-Control-Allow-Origin', '*')
  .set('Accept', 'application/json');

// Options for GlobalQuestionService.generatePDF() — the shared Go/Playwright pdf-service
// entry point. extraParams carries any identifier the service's named fields don't cover
// (e.g. period_no, begin_date/end_date, version_id_1/version_id_2, item_id); the Go side
// passes these straight through onto the target URL (see pdf-service/internal/pdfgen).
// There is deliberately no quoteId here: the Go service's Request struct (generator.go) only
// recognizes session_id/policy_id/token_id/document_id as page identifiers, so a bare quote_id
// trips its "identifier is required" 400 before it ever navigates anywhere. Callers rendering
// a pre-bind quote must resolve it to a session_id first (dbo.quote.new_session_id, or the
// 'Session ID' row getQuotePolicySchedule already renders into the Details table) and pass
// that as sessionId instead — see DocPolicyQuoteComponent.preparePDF().
export interface PdfGenerateOpts {
  sessionId?: string;
  tokenId?: string;
  policyId?: string;
  classId?: string;
  productId?: string;
  documentId?: string;
  cssHref?: string;
  extraParams?: Record<string, string>;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalQuestionService implements OnChanges {

  
  //@ViewChild("trafficCop") trafficCop: QuestionTrafficCopComponent;
  
  private messageSource = new BehaviorSubject(false);
  unreadNotificationCount = new BehaviorSubject<number>(0);
  summaryData: Observable<any>;
  summaryDataSubject: BehaviorSubject<any>;
  spinnerSubject = new BehaviorSubject(false);
  spinnerTransparentSubject = new BehaviorSubject(false);
  spinnerObservable = this.spinnerSubject.asObservable();
  spinnerTransparentObservable = this.spinnerTransparentSubject.asObservable();
  errorMessageSubject = new BehaviorSubject(false);
  errorMessageObservable = this.errorMessageSubject.asObservable();
  pdfPreviewSubject = new BehaviorSubject<SafeResourceUrl | null>(null);
  pdfPreviewObservable = this.pdfPreviewSubject.asObservable();
  private previewObjectUrl: string | null = null;
  CallProc = this.messageSource.asObservable();
  categoryCss = 'personal';
  getVaps = new BehaviorSubject(false);
  person: any;
  accounting: any;
  currency: any;
  selectedItem: any;
  selectedCoverItem: any;
  selectedMiniFlowItem: any;
  pageInfoSubject: BehaviorSubject<PageInfo[]> = new BehaviorSubject(null);
  pageInfoObservable = this.pageInfoSubject.asObservable();
  private rawHttp!: HttpClient;

  constructor(
    private httpClient: HttpClient,
    private flowPlayer: FlowPlayerService,
    private questionStore: QuestionStore,
    private questionQuery: QuestionQuery,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    private itemsQuery: ItemsQuery,
    private itemsStore: ItemsStore,
    private superflowStore: SuperflowStore,
    private superflowQuery: SuperflowQuery,
    private userStore: UserStore,
    private shoppingCartStore: ShoppingCartStore,
    private shoppingCartQuery: ShoppingCartQuery,
    private miniQuestionStore: MiniQuestionStore,
    private miniQuestionQuery: MiniQuestionQuery,
    private miniFlowSessionQuery: MiniQuestionFlowSessionQuery,
    private router: Router,
    private miniFlowPlayerService: MiniFlowPlayerService,
    private httpBackend: HttpBackend,
    private sanitizer: DomSanitizer,
    private storageService: StorageService
  ) {
    this.rawHttp = new HttpClient(this.httpBackend);
    this.person = this.userStore.getValue();

    this.summaryDataSubject = new BehaviorSubject<any>(false);
    this.summaryData = this.summaryDataSubject.asObservable();
    // accounting.settings = {
    //   currency: {
    //     symbol: 'R ', // default currency symbol is '$'
    //     format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
    //     decimal: '.', // decimal point separator
    //     thousand: ' ', // thousands separator
    //     precision: 0, // decimal places
    //   },
    //   number: {
    //     precision: 0, // default precision on numbers is 0
    //     thousand: ' ',
    //     decimal: '.',
    //   }
    // };
    // this.accounting = accounting;
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  spinner(value: boolean): void {
    this.spinnerSubject.next(value);
  }
  spinnerTransparent(value: boolean): void {
    this.spinnerTransparentSubject.next(value);
  }

  showPDFPreview(url: string): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
    }
    this.previewObjectUrl = url;
    this.pdfPreviewSubject.next(this.sanitizer.bypassSecurityTrustResourceUrl(url));
  }

  clearPDFPreview(): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
      this.previewObjectUrl = null;
    }
    this.pdfPreviewSubject.next(null);
  }

  calculateProgress(questions: Question[]): number {
    const totalQuestions = questions?.length;
    if (totalQuestions <= 0) {
      return 0;
    }
    const answeredQuestions = questions.filter((q: Question) => q.answer);
    return answeredQuestions.length / totalQuestions;
  }

  setErrorMessage(value: boolean): void {
    this.errorMessageSubject.next(value);
  }

  resetVaps(value: boolean): void {
    this.getVaps.next(value);
  }
  
  // setCategoryCss(css: string): void {
  //   this.categoryCss = css;
  //   console.log(this.categoryCss);

  // }
  // getCategoryCss(): string {
  //   return this.categoryCss;
  // }
  callProc(value: boolean): void {
    this.messageSource.next(value);
  }

  getPageQuestions(page: number): Observable<any> {
    return this.questionQuery.selectAll({
      filterBy: [
        entity => entity.page !== null && entity.page !== undefined && entity.page === page
      ]
    });
  }

  getQuoteLinks(): Observable<QuoteCategory[]> {
    return this.httpClient.get<QuoteCategory[]>(`${API_PATH.GET_QUOTE_LINKS}`, {headers});
  }

  // Shared by the quote loader (always fetches) and the quote screen (fetches only as a fallback when the loader didn't run in this tab).
  getQuotePageData(page: string, session_id: string = '', category_id: string = '', product_group_id: string = '', user_updated: string = '0'): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    if (session_id === '') session_id = session_details?.session_id;
    if (category_id === '') category_id = session_details?.category_id;
    if (product_group_id === '') product_group_id = session_details?.group_id;
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_id);
    parameters.set('category_id', category_id);
    parameters.set('product_group_id', product_group_id);
    parameters.set('page', page);
    parameters.set('user_updated', user_updated);
    return this.runCommandNew('getQuotePageData', parameters, true);
  }

  // The page procs answer a session that can no longer be quoted (e.g. one already converted to a policy) with a single
  // index-0 row - header, body and a JSON string of buttons - in place of the page data. Returns that row with the
  // buttons parsed, or null for a normal payload (whose first row is index 1 and can carry a header of its own).
  getIndex0(datasets: any[][]): any {
    const row = datasets?.[0]?.[0];
    if (row?.index !== 0 || !row?.header) {
      return null;
    }
    let buttons: any[] = null;
    try {
      buttons = JSON.parse(row.buttons);
    } catch { }
    // The proc sends everyone to the client dashboard; a broker or console user goes to policy holders instead.
    const user = this.userStore.getValue();
    if (Array.isArray(buttons) && (user?.broker_id > 0 || user?.console_access)) {
      buttons.forEach(button => {
        if (button?.url === RouterLinks.DashboardLanding) {
          button.url = RouterLinks.PolicyHolders;
        }
      });
    }
    return {...row, buttons};
  }

  getDateRanges(): Observable<any[]> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    return this.runCommandNew(`getClaimsDateRange`, parameters);
  }

  getNextPage(product_id: number, page: string, referer_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    return this.httpClient.get(`${API_PATH.GET_NEXT_PAGE}/${session_details.session_id}/${session_details.category_id}/${session_details.group_id}/${product_id}/${page}/${referer_id}`);
  }

  validateBankAccount(account_number : string, brance_code: string, account_type: string): Observable<any> {
    return this.httpClient.get(`${API_PATH.VALIDATE_BANK_ACCOUNT}/${account_number}/${brance_code}/${account_type}`);
  }

  removeFile(resource_id: string): Observable<any> {
    return this.httpClient.delete(`${API_PATH.DELETE_RESOURCE}?resource_id=${resource_id}`);
  }

  getPresignedUploadUrl(sessionId: string, evidenceType: string, contentType: string): Observable<any> {
    return this.httpClient.post(`${environment.eviBaseEndpoint}/upload-url`, {
      session_id: sessionId,
      evidence_type: evidenceType,
      content_type: contentType
    }, {
      headers: new HttpHeaders({
        'x-api-key': environment.eviValidateKey,
        'Content-Type': 'application/json'
      })
    });
  }

  uploadToS3(url: string, fields: Record<string, string>, file: File): Observable<any> {
    const formData = new FormData();
    Object.entries(fields).forEach(([key, value]) => formData.append(key, value));
    formData.append('file', file);
    return from(
      fetch(url, { method: 'POST', body: formData }).then(res => {
        if (!res.ok && res.status !== 204) {
          throw new Error(`S3 upload failed with status ${res.status}`);
        }
        return res;
      })
    );
  }

  validateEvidence(evidenceId: string, evidenceType: string): Observable<any> {
    return this.httpClient.post(`${environment.eviBaseEndpoint}/validate`, {
      evidence_id: evidenceId,
      evidence_type: evidenceType
    }, {
      headers: new HttpHeaders({
        'x-api-key': environment.eviValidateKey,
        'Content-Type': 'application/json'
      })
    });
  }

  processEvidence(evidenceId: string, sessionId: string, evidenceType: string, questionId: string, aiSchemaName: string, itemId: string): Observable<any> {
    return this.httpClient.post(`${environment.eviBaseEndpoint}/${evidenceId}/process`, {
      session_id: sessionId,
      evidence_type: evidenceType,
      question_id: questionId,
      ai_schema_name: aiSchemaName,
      item_id: itemId
    }, {
      headers: new HttpHeaders({
        'x-api-key': environment.eviValidateKey,
        'Content-Type': 'application/json'
      })
    });
  }

  pollEvidenceStatus(evidenceId: string): Observable<any> {
    const terminalStatuses = ['EXTRACTING', 'VALIDATED', 'ERROR', 'FAILED', 'REJECTED'];
    return timer(0, 3000).pipe(
      switchMap(() => this.httpClient.get(`${environment.eviBaseEndpoint}/${evidenceId}/status`, {
        headers: new HttpHeaders({ 'x-api-key': environment.eviValidateKey })
      })),
      takeWhile((res: any) => !terminalStatuses.includes(res?.status), true)
    );
  }

  getUploadedFileDetails(resource_id: string): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_RESOURCE_DETAILS}/${resource_id}`);
  }

  getVehicleMakes(): Observable<VehicleMake[]> {
    const parameters = new Map<string, string>();
    return this.runCommandNew(`getMakes`, parameters);
  }

  getVehicleModels(year: string, make: string): Observable<VehicleModel[]> {
    const parameters = new Map<string, string>();
    parameters.set('year', year);
    parameters.set('make', make);
    return this.runCommandNew(`getModels`, parameters);
  }

  getVehicleYears(make: string): Observable<VehicleYear[]> {
    const parameters = new Map<string, string>();
    parameters.set('make', make);
    return this.runCommandNew(`getYears`, parameters);
  }

  updateClaim(question_id: any, complete: any): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('complete', complete);
    parameters.set('question_id', question_id);
    parameters.set('flow_id', session_details?.flow_id);

    return this.runCommandNew('updateClaim', parameters);
  }

  setClaimRegistered(): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    return this.runCommandNew('setClaimRegistered', parameters);
  }

  updateClaim2(claim_id: number, current_version_id: number, action_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();

    parameters.set('claim_id', claim_id.toString());
    parameters.set('new_session_id', session_details?.session_id);
    parameters.set('current_version_id', current_version_id.toString());
    parameters.set('action_id', action_id.toString());


    return this.runCommandNew('updateClaim2', parameters);
  }

  getClaim(session_id: string =''): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    if (session_id === '') session_id = session_details?.session_id;
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_id);
    return this.runCommandNew('getClaimDetails', parameters);
  }

  evaluateClaimCompletionStatus(session_id: string = ''): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    if (session_id === '') session_id = session_details?.session_id;
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_id);
    return this.runCommandNew('evaluateClaimCompletionStatus', parameters);
  }

  getMiniFlowItems(question: Question, item_id?: string): Observable<any[]> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('class_id', question?.product_class_id.toString());
    parameters.set('flow_id', question?.flow_id.toString());
    parameters.set('group_id', session_details?.group_id?.toString());
    if (item_id) {
      parameters.set('item_id', item_id);
    }
    return this.runCommandNew(`getMiniFlow_player_items`, parameters);
  }


  getChildrenQuestions(parentId: number): Observable<any> {
    return this.questionQuery.selectAll({
      filterBy: [
        entity => entity.parent_control !== null && entity.parent_control !== undefined && entity.parent_control === parentId
      ]
    });
  }

  getFlowQuestionByIdFromAkita(id: number): Observable<Question> {
    return this.questionQuery.selectEntity(({cent_aq_question_id}) => cent_aq_question_id === id);
  }

  getPersonCategories(person_id: any): Observable<any> {
    const parameters = new Map<string, string>();
    parameters.set('person_id', person_id?.toString());
    return this.runCommandNew(`getPersonCategories`, parameters);
  }

  saveFlowHistory(session_id: string, flow_id: number, item_id: string, question_id: number, next: number, class_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    return this.httpClient.get(`${API_PATH.SAVE_FLOW_HISTORY}/${session_id}/${session_details.superflow_id}/${flow_id}/${item_id}/${question_id}/${next}/${class_id}`);
  }

  getPrevious(session_id: string, flow_id: number, item_id: string, question_id: number): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_PREVIOUS}/${session_id}/${flow_id}/${item_id}/${question_id}`);
  }

  getShoppingCart(question_id: number, page = 'question-flow', frequency_id = 0, product_id = 0): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    // let cart_type = '';
    // if (session_details?.superflow_id === Superflow.personal_claim || session_details?.superflow_id === Superflow.general_claim) {
    //   cart_type = CartTypes.claim;
    // } else {
    //   cart_type = CartTypes.acquisition;
    // }
    let group_id =  0 ;
     if (session_details?.group_id){
       group_id = session_details?.group_id;
     }
    return this.httpClient.get(`${API_PATH.GET_SHOPPINGCART}/${session_details?.session_id}/${question_id}/${session_details?.category_id}/${group_id}/${session_details?.flow_id}/${page}/${frequency_id}/${product_id}`,
      {context: new HttpContext().set(SILENT_ERROR, true)});
  }

  getShoppingCartQcap(product_id: number, frequency_id: number, referer_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    let cart_type = '';
    if (session_details?.superflow_id === Superflow.personal_claim) {
      cart_type = CartTypes.claim;
    } else {
      cart_type = CartTypes.acquisition;
    }
    return this.httpClient.get(`${API_PATH.GET_SHOPPINGCARTQCAP}/${session_details?.session_id}/${session_details?.category_id}/${session_details?.group_id}/${product_id}/${frequency_id}/${referer_id}`);
  }

  getFlowItems(): any {
    const session_details = this.questionFlowSessionQuery.getValue();
    return this.httpClient.get(`${API_PATH.GET_FLOW_ITEMS}/${session_details.session_id}/${session_details.superflow_id}`);
  }

  saveAnswer(session_id: string, question_id: number, class_id: number, item_id: string, answer: string, answer_id: number, comment: string, flow_id = 0, response_parameters = null, vaps_id = null, location_id = 0, skipped = 0): Observable<any> {
    
    if (flow_id == null) {
      flow_id = 0;
    }
    let user_updated = this.person?.person_id.toString();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_id);
    parameters.set('answer', answer);
    parameters.set('question_id', question_id.toString());
    parameters.set('product_class_id', class_id.toString());
    parameters.set('item_id', item_id);
    parameters.set('answer_id', answer_id.toString());
    parameters.set('flow_id', flow_id.toString());
    parameters.set('parameters', response_parameters ?? '');
    parameters.set('vaps_id', vaps_id);
    parameters.set('location_id', location_id.toString());
    parameters.set('user_updated', user_updated);
    parameters.set('skipped', skipped.toString());
    if (comment) {
      parameters.set('comment', comment);
    }
    return this.runCommandNew('saveAnswer', parameters);
  }

  /*saveAnswers(answers: Answer[]): Observable<any> {
    const bodyAnswers = [];
    answers.forEach((answer: Answer) => {
      bodyAnswers.push({
        SessionId: answer.session_id,
        QuestionId: answer.question_id,
        ProductClassId: answer.product_class_id,
        ItemId: answer.item_id,
        Answer: answer.answer,
        AnswerId: answer.answer_id,
        FlowId: answer.flow_id
      });
    });
    const requestBody = {
      Answers: bodyAnswers
    };
    return this.httpClient.post(`${API_PATH.SAVE_ANSWERS}`, requestBody);
  }*/

  getNextQuestion(currentQuestion: Question, session_id: any, item_id: any, flow_id: any, index: any): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_NEXT_QUESTION}/${session_id}/${item_id}/${currentQuestion.cent_aq_question_id}/${flow_id}/${0}`);
  }

  // getNextQuestion2(currentQuestion: Question, session_id: any, item_id: any, flow_id: any, index: any): Observable<any> {
  //   return this.httpClient.get(`${API_PATH.GET_NEXT_QUESTION2}/${session_id}/${item_id}/${currentQuestion.cent_aq_question_id}/${flow_id}/${0}`);
  // }
  getQuestion(currentQuestionId: any): Observable<Question[]> {
    return this.questionQuery.getById(currentQuestionId);
  }

  getMiniQuestion(currentQuestionId: number): Observable<Question[]> {
    return this.miniQuestionQuery.getById(currentQuestionId);
  }

  getItemList(question_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details.session_id);
    parameters.set('question_id', `${question_id}`);
    parameters.set('group_id', `${session_details.group_id}`);
    return this.runCommandNew('getItemList', parameters);
  }

  getIndustries(): Observable<Industry[]> {
    return this.runCommandNew('getIndustries', new Map<string, string>());
  }

  getProfessions(): Observable<Profession[]> {
    return this.runCommandNew('getProfessions', new Map<string, string>());
  }

  runCommand(command: string): Observable<any> {
    return this.httpClient.get(`${API_PATH.RUN_COMMAND}/${encodeURIComponent(command)}`);
  }

  runCommandNew(command: string, parameters: Map<string, string>, multiple: boolean = false, context?: HttpContext): Observable<any> {
    const parametersObject = {};
    for (const [key, value] of parameters) {
      parametersObject[key] = value;
    }

    const requestBody: any = {
      Parameters: parametersObject,
      Command: command,
      Dataset: multiple
    };

    return this.httpClient.post(`${API_PATH.RUN_NEW_COMMAND}`, requestBody, context ? {headers, context} : {headers});
  }
  runCommandForMultipleDatasets(command: string, seperatedData: boolean): Observable<any> {
    return this.httpClient.get(`${API_PATH.RUN_COMMAND_MULTIPLE_DATASETS}/${command}/isSeperatedData?isSeperatedData=${seperatedData}`);
  }

  replaceCallProcParemeters(call_proc: string, item_id: any, session_id: string, class_id: any, page: any, flowId: any, question_id: any, group_id?: any, category_id?: any): any {
    const person = this.userStore?.getValue();
    let person_id = null;
    try {
      person_id = this.storageService.get('context_person_id', 'user');
      if (person_id) {
        console.log(person_id);
      }
      else {
        person_id = person?.person_id?.toString();
      }
    }
    catch { }
    return call_proc
      .replace(/{session_id}/g, session_id)
      .replace(/{item_id}/g, item_id)
      .replace(/{page}/g, page)
      .replace(/{class_id}/g, class_id)
      .replace(/{question_id}/g, question_id)
      .replace(/{person_id}/g, person_id)
      .replace(/{flow_id}/g, flowId)
      .replace(/{group_id}/g, group_id)
      .replace(/{category_id}/g, category_id);
  }

  removeRiskListItem(classId: any, itemId: string): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', sessionDetails?.session_id);
    parameters.set('product_class_id', `${classId}`);
    parameters.set('item_id', itemId);
    return this.runCommandNew('removeItem', parameters);
  }

  getLists(question_id: any): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', sessionDetails?.session_id);
    parameters.set('question_id', `${question_id}`);
    parameters.set('group_id', `${sessionDetails?.group_id}`);
    parameters.set('flow_id', `${sessionDetails?.flow_id}`);
    parameters.set('category_id', `${sessionDetails?.category_id}`);
    return this.runCommandNew('getItemList', parameters);
  }

  getPremium(classId: any, itemId: any, productId: any, vapId = 0): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    let vaps_id = 0;
    if (vapId) vaps_id = vapId;
    const parameters = new Map<string, string>();
    parameters.set('class_id', `${classId}`);
    parameters.set('session_id', sessionDetails?.session_id);
    parameters.set('item_id', `${itemId}`);
    parameters.set('product_id', `${productId}`);
    parameters.set('category_id', `${sessionDetails?.category_id}`);
    parameters.set('prem_flag', '1');
    parameters.set('product_group_id', `${sessionDetails?.group_id}`);
    parameters.set('vaps_id', `${vaps_id}`);
    return this.runCommandNew('getPremium', parameters);
  }

  calcPremiumAddons(vapId: any, itemId: any, productId: any): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', sessionDetails?.session_id);
    parameters.set('product_vaps_input', `${vapId}`);
    parameters.set('item_id', `${itemId}`);
    parameters.set('product_id', `${productId}`);
    parameters.set('category_id', `${sessionDetails?.category_id}`);
    return this.runCommandNew('calcPrem_addons_2', parameters);
  }

  updatePrices(productId: any, classId: any, itemId: any): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    const command = `exec updatePrices ${sessionDetails?.category_id}, ${sessionDetails?.session_id}, ${sessionDetails?.flow_id}, ${productId}, ${classId}, ${sessionDetails?.group_id}, ${itemId}, 1`;

    return this.runCommandForMultipleDatasets(command, true);
  }

  getPageData(page: any): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    const command = `exec getPageData ${sessionDetails?.session_id}, ${sessionDetails?.category_id}, ${sessionDetails?.group_id}, ${page}`;
    return this.runCommandForMultipleDatasets(command, false);
  }

  collateCalcs(product_id: any, class_id: any): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details.session_id);
    parameters.set('category_id', `${session_details.category_id}`);
    parameters.set('product_group', `${session_details.group_id}`);
    parameters.set('class_id', `${class_id}`);
    parameters.set('product_id', `${product_id}`);
    parameters.set('item_id', '0');
    return this.runCommandNew('collateCalcs', parameters);
  }

  saveIndividualAnswer(question: Question, itemId: any): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    let answer_id = question.answer_id;
    let session_id = question?.session_id;
    if (!answer_id) {
      answer_id = 0;
    }
    if (!session_id){
      session_id = sessionDetails?.session_id.toString();
    }
    const skipped = question?.answer === 'skipped' ? 1 : 0;
    return this.saveAnswer(session_id, question.cent_aq_question_id, question?.product_class_id, itemId.toString(), question?.answer, answer_id, question?.comment, question.flow_id, question?.parameters, null, question?.location_id, skipped);
  }

  getResponses(): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', sessionDetails?.session_id);
    parameters.set('group_id', sessionDetails?.group_id);
    parameters.set('flow_id', sessionDetails?.flow_id);
    /*const command = `exec getResponses ${sessionDetails?.session_id}, ${sessionDetails?.group_id},${sessionDetails?.flow_id}`;*/
    return this.runCommandNew('getResponses', parameters);
  }

  getProducts(product_id: any, class_id: any, tpq = false): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();

    parameters.set('categoryid', sessionDetails?.category_id);
    parameters.set('session_id', sessionDetails?.session_id);
    parameters.set('flow_id', sessionDetails?.flow_id);
    parameters.set('product_id', product_id);
    parameters.set('class_id', class_id);
    parameters.set('group_id', sessionDetails?.group_id);
    parameters.set('collate', '1');

    if (tpq) {
      parameters.set('tpq_only', '1');
    }

    /*const command = `exec getProducts ${sessionDetails?.category_id}, ${sessionDetails?.session_id}, ${sessionDetails?.flow_id}, ${product_id}, ${class_id}, ${sessionDetails?.group_id}, 1`;
    return this.runCommandForMultipleDatasets(command, true);*/
    return this.runCommandNew('getProducts', parameters, true);
  }

  removeAnswer(session_id: string, question_id: any, answer_id: any, class_id: any, item_id: string, answer: string): Observable<any> {
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_id);
    parameters.set('question_id', question_id);
    parameters.set('answer_id', answer_id);
    parameters.set('product_class_id', class_id);
    parameters.set('item_id', item_id);
    parameters.set('answer', answer);

    return this.runCommandNew('removeAnswer', parameters);
  }

  insertUploadAnswer(session_id: string, question_id: any, answer_id: any, class_id: any, item_id: string, answer: string): Observable<any> {
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_id);
    parameters.set('question_id', question_id);
    parameters.set('answer_id', answer_id);
    parameters.set('product_class_id', class_id);
    parameters.set('item_id', item_id);
    parameters.set('answer', answer);

    return this.runCommandNew('insertUploadAnswer', parameters);
  }

  getQuestionGrouping(): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('category_id', sessionDetails?.category_id);
    parameters.set('session_id', sessionDetails?.session_id);
    return this.runCommandNew('getQuestionGrouping', parameters);
  }

  saveParentChildren(questions: Question[]): Observable<any> {
    const sessionDetails = this.questionFlowSessionQuery.getValue();
    return from(questions).pipe(
      mergeMap(q => this.saveAnswer(sessionDetails?.session_id, q.cent_aq_question_id, q?.product_class_id, q?.item_id, q.answer, (q?.answer_id ? q.answer_id : 0), q?.comment) as Observable<any>)
    );
  }


  updateItems(): void {
    this.itemsStore.reset();
    const session_items: any[] = [];
    this.getFlowItems()
      .subscribe((items: any[]) => {
        if (!items) {
          return;
        }
        items.forEach((item: any) => {
          const class_id = item.class_id;
          const flowItems = item.items?.split('|');
          flowItems.forEach((i: any) => {
            const id = `${i}_${class_id}`;
            if (this.itemsQuery.hasEntity(id) === false) {
              const flowItem = {
                id,
                class_id,
                item_id: i
              };
              session_items.push(flowItem);
            }
          });
        });
      });

    if (session_items.length > 0) {
      this.itemsStore.set(session_items);
    }
  }


  setActiveItem(activeId: any): void {
    this.itemsStore.setActive(activeId);
  }

  getActiveItem(): any {
    return this.itemsQuery.getActive();
  }

  getResponse(question_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();

    parameters.set('session_id', session_details?.session_id?.toString());
    parameters.set('question_id', question_id?.toString());

    return this.runCommandNew('getResponse', parameters);
  }

  saveAnswerOnly(question: Question): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const answer_id = question.answer_id ? question.answer_id : 0;

    /*const item_id = (question?.item_id ? question?.item_id : '0') === '0' ? (session_details?.item_id ? session_details?.item_id : '0') : question?.item_id;*/
    const item_id = question?.item_id ? question?.item_id : '0';

    const class_id = (question?.product_class_id ? question?.product_class_id : 0) === 0 ? (session_details?.class_id ? session_details?.class_id : 0) : question?.product_class_id;
    const skipped = question?.answer === 'skipped' ? 1 : 0;
    const flow_id = question?.flow_id || session_details.flow_id;
    return this.saveAnswer(session_details?.session_id, question.cent_aq_question_id, class_id, item_id, question.answer, answer_id, question?.comment, flow_id, question?.response_parameters, question?.vaps_id, question?.location_id, skipped);
  }
  saveAnswersOnly(questions: any): void {
    this.saveAnswers(questions).subscribe();
  }

  saveAnswers(questions: any): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();

    const saves = questions.map(q => {
      const answer_id = q.answer_id ? q.answer_id : 0;

    /*const item_id = (question?.item_id ? question?.item_id : '0') === '0' ? (session_details?.item_id ? session_details?.item_id : '0') : question?.item_id;*/
      const item_id = q?.item_id ? q?.item_id : '0';
      const class_id = (q?.product_class_id ? q?.product_class_id : 0) === 0 ? (session_details?.class_id ? session_details?.class_id : 0) : q?.product_class_id;
      const skipped = q?.answer === 'skipped' ? 1 : 0;
      return this.saveAnswer(session_details?.session_id, q.cent_aq_question_id, class_id, item_id, q.answer, answer_id, q?.comment, session_details.flow_id, q?.response_parameters, q?.vaps_id, q?.location_id, skipped);
    });
    return saves.length ? forkJoin(saves) : of([]);
  }

  runProcOnly(question: Question): any {
    const session_details = this.questionFlowSessionQuery.getValue();

    if (question.call_proc !== null && question.call_proc !== '') {
      return this.runCommand(
        this.replaceCallProcParemeters(
          question.call_proc,
          (question?.item_id ? question?.item_id : '0'),
          session_details?.session_id,
          (question?.product_class_id ? question?.product_class_id : 0),
          question.page,
          session_details?.flow_id,
          question.cent_aq_question_id,
          session_details?.group_id,
          question?.category_id
        ))
        .subscribe((val: any[]) => {
          if (!val?.length) {
            return undefined;
          }
          if (val[0]) {
            let retrieved = false;
            if (val[0]?.next) {

              return this.getQuestion(val[0].next)
                .subscribe((q: any[]) => {
                  if (!q?.length) {
                    return;
                  }
                  if (q[0]) {
                    if (retrieved === true) {
                      return;
                    } else {
                      const question_id = q[0].cent_aq_question_id;

                      this.flowPlayer.flowQuestions(session_details?.flow_id, session_details?.category_id, session_details?.session_id, session_details?.group_id, q[0].item_id)
                        .subscribe((v: any) => {
                          if (!v) {
                            return;
                          }
                          retrieved = true;

                          this.setShoppingCart(q[0], question?.item_id ? question?.item_id : session_details?.item_id ? session_details?.item_id : '1')
                            .add(() => {
                              /*v = this.cleanQuestions(v);*/
                              this.questionStore.set(v);
                              this.questionStore.setActive(question_id);
                            });
                        });
                    }
                  }

                });
            }
          }
          return this.getNext(
            question,
            session_details?.session_id,
            (question?.item_id ? question?.item_id : '0'),
            session_details?.flow_id,
            session_details?.category_id,
            question.index,
            session_details?.superflow_id,
            session_details?.group_id
          );
        });
    } else {
      return this.getNext(
        question,
        session_details?.session_id,
        (question?.item_id ? question?.item_id : '0'),
        session_details?.flow_id,
        session_details?.category_id,
        question.index,
        session_details?.superflow_id,
        session_details?.group_id
      );
    }
  }

  saveResponses(questions: Question[], location_id: number = 0): any {
    const session_details = this.questionFlowSessionQuery.getValue();

    return forkJoin(
      questions.map(question => {
        const answer_id = question.answer_id ? question.answer_id : 0;
        const class_id = (question?.product_class_id ? question?.product_class_id : 0) === 0 ? (session_details?.class_id ? session_details?.class_id : 0) : question?.product_class_id;
        const item_id = question?.item_id ? question?.item_id : '0';
        const skipped = question?.answer === 'skipped' ? 1 : 0;
        return this.saveAnswer(session_details?.session_id, question?.cent_aq_question_id, class_id, item_id, question?.answer, answer_id, question?.comment, session_details?.flow_id, question?.response_parameters, null, location_id, skipped);
      }))
    /*return this.saveAnswers(answers)*/
      .subscribe(() => {
          if (questions[0]?.call_proc) {
            return this.runCommand(
              this.replaceCallProcParemeters(
                questions[0]?.call_proc,
                questions[0]?.item_id,
                session_details?.session_id,
                (questions[0]?.product_class_id ? questions[0]?.product_class_id : 0),
                questions[0]?.page,
                session_details?.flow_id,
                questions[0]?.cent_aq_question_id,
                session_details?.group_id,
                questions[0]?.category_id
              )
            ).subscribe((val: any[]) => {
              if (!val?.length) {
                return;
              }
              if (val[0]) {
                let retrieved = false;
                if (val[0]?.next) {
                  this.saveFlowHistory(session_details.session_id, questions[0].flow_id, questions[0].item_id, questions[0].cent_aq_question_id, val[0].next, questions[0].product_class_id).subscribe((response: any) => {
                  });
                  return this.getQuestion(val[0].next)
                    .subscribe((q: any) => {
                      if (!q) {
                        return;
                      }
                      if (q[0] !== undefined) {
                        if (retrieved === true) {
                          return;
                        } else {
                          const question_id = q[0].cent_aq_question_id;
                          this.flowPlayer.flowQuestions(session_details?.flow_id, session_details?.category_id, session_details?.session_id, session_details?.group_id, q[0]?.item_id)
                            .subscribe((v: any) => {
                              if (!v) {
                                return;
                              }
                              retrieved = true;

                              this.setShoppingCart(q[0], (questions[0]?.item_id ? questions[0]?.item_id : '0') === '0' ? (session_details?.item_id ? session_details?.item_id : '0') : questions[0]?.item_id)
                                .add((sub: any) => {
                                  /*v = this.cleanQuestions(v);*/
                                  this.questionStore.set(v);
                                  this.questionStore.setActive(question_id);

                                });
                            });
                        }
                      }

                    });
                }
              }
              return this.getNext(
                questions[0],
                session_details?.session_id,
                (questions[0]?.item_id ? questions[0]?.item_id : '0') === '0' ? (session_details?.item_id ? session_details?.item_id : '0') : questions[0]?.item_id,
                session_details?.flow_id,
                session_details?.category_id,
                questions[0].index,
                session_details?.superflow_id,
                session_details?.group_id
              );
            });
          }
          return this.getNext(
            questions[0],
            session_details?.session_id,
            // (session_details?.item_id ? session_details?.item_id : "0"),
            questions[0].item_id,
            session_details?.flow_id,
            session_details?.category_id,
            questions[0].index,
            session_details?.superflow_id,
            session_details?.group_id
          );
        },
        err => {
          console.log(err);

        });
  }

  /*saveResponseMiniFlow(question: Question): any {
    const session_details = this.miniFlowSessionQuery.getValue();
    const answer_id = question.answer_id ? question.answer_id : 0;
    const item_id = question?.item_id ? question?.item_id : '0';
    const class_id = (question?.product_class_id ? question?.product_class_id : 0) === 0 ? (session_details?.class_id ? session_details?.class_id : 0) : question?.product_class_id;
    return this.saveAnswer(session_details?.session_id, question.cent_aq_question_id, class_id, item_id, question.answer, answer_id, question?.comment, session_details.flow_id)
      .subscribe(() => {
        if (question.call_proc !== null && question.call_proc !== '') {
          return this.runCommand(
            this.replaceCallProcParemeters(
              question.call_proc,
              item_id,
              session_details?.session_id,
              (question?.product_class_id ? question?.product_class_id : 0),
              question.page,
              session_details?.flow_id,
              question.cent_aq_question_id,
              session_details?.group_id,
              question?.category_id
            ))
            .subscribe((val: any[]) => {
              if (val?.length) {
                if (val[0]) {
                  let retrieved = false;
                  if (val[0]?.next) {
                    this.saveFlowHistory(session_details?.session_id, question?.flow_id, question?.item_id, question?.cent_aq_question_id, val[0]?.next, question?.product_class_id);
                    return this.getMiniQuestion(val[0]?.next)
                      .subscribe((q: any[]) => {
                        if (q?.length) {
                          if (q[0]) {
                            if (retrieved === true) {
                              return;
                            } else {
                              const question_id = q[0]?.cent_aq_question_id;
                              this.flowPlayer.flowQuestions(question?.flow_id, session_details?.category_id, session_details?.session_id, session_details?.group_id, q[0]?.item_id)
                                .subscribe((flowQuestions: any[]) => {
                                  if (flowQuestions?.length) {
                                    retrieved = true;
                                    this.setShoppingCart(q[0], item_id)
                                      .add(() => {
                                        flowQuestions = this.cleanQuestions(flowQuestions);
                                        this.miniQuestionStore.set(flowQuestions);
                                        this.miniQuestionStore.setActive(question_id);
                                      });
                                  }
                                });
                            }
                          }
                        }
                      });
                  }
                }
              } else {
                return this.getMiniFlowNext(
                  question,
                  session_details?.session_id,
                  item_id,
                  session_details?.flow_id,
                  session_details?.category_id,
                  question.index,
                  session_details?.superflow_id,
                  session_details?.group_id
                );
              }
            });
        } else {
          return this.getMiniFlowNext(
            question,
            session_details?.session_id,
            item_id,
            session_details?.flow_id,
            session_details?.category_id,
            question.index,
            session_details?.superflow_id,
            session_details?.group_id
          );
        }
      });
  }*/

  saveResponse(question: Question, navigate: string = ''): any {
    const session_details = this.questionFlowSessionQuery.getValue();
    const answer_id = question.answer_id ? question.answer_id : 0;

    /*const item_id = (question?.item_id ? question?.item_id : '0') === '0' ? (session_details?.item_id ? session_details?.item_id : '0') : question?.item_id;*/
    const item_id = question?.item_id ? question?.item_id : '0';
    const class_id = (question?.product_class_id ? question?.product_class_id : 0) === 0 ? (session_details?.class_id ? session_details?.class_id : 0) : question?.product_class_id;
    const skipped = question?.answer === 'skipped' ? 1 : 0;
    return this.saveAnswer(session_details?.session_id, question.cent_aq_question_id, class_id, item_id, question.answer, answer_id, question?.comment, session_details.flow_id, question?.response_parameters, null, question?.location_id, skipped)
      .subscribe((result: any) => {
          if (question.call_proc !== null && question.call_proc !== '') {
            /* $('.layout__main').hide();*/
            return this.runCommand(
              this.replaceCallProcParemeters(
                question.call_proc,
                item_id,
                session_details?.session_id,
                (question?.product_class_id ? question?.product_class_id : 0),
                question.page,
                session_details?.flow_id,
                question.cent_aq_question_id,
                session_details?.group_id,
                question?.category_id
              ))
              .subscribe((val: any[]) => {
               
                if (!val?.length) {
                  return undefined;
                }

                if (val[0]) {
                  let retrieved = false;
                  if (val[0]?.next) {
                    this.saveFlowHistory(session_details.session_id, question.flow_id, question.item_id, question.cent_aq_question_id, val[0].next, question.product_class_id).subscribe((response: any) => {
                    });
                    return this.getQuestion(val[0].next)
                      .subscribe((q: Question[]) => {
                        if (!q?.length) {
                          return;
                        }

                        if (q[0]) {
                          if (retrieved === true) {
                            return;
                          } else {
                            const question_id = q[0].cent_aq_question_id;
                            /*if (val?.length && val[0]?.next) {
                              question_id = val[0]?.next;
                            }*/

                            this.flowPlayer.flowQuestions(session_details?.flow_id, session_details?.category_id, session_details?.session_id, session_details?.group_id, q[0].item_id)
                              .subscribe((v: any) => {
                                if (!v) {
                                  return;
                                }
                                retrieved = true;

                                this.setShoppingCart(q[0], item_id)
                                  .add(() => {
                                    /*v = this.cleanQuestions(v);*/
                                    this.questionStore.set(v);
                                    this.questionStore.setActive(question_id);
                                    if (navigate?.length > 0) {
                                      this.router.navigate([`/${navigate}`]);
                                    }
                                  });
                                this.callProc(false);
                              });
                          }
                        }

                      });
                  }
                }
                return this.getNext(
                  question,
                  session_details?.session_id,
                  item_id,
                  session_details?.flow_id,
                  session_details?.category_id,
                  question.index,
                  session_details?.superflow_id,
                  session_details?.group_id,
                  navigate
                );
              });
          } else {
            return this.getNext(
              question,
              session_details?.session_id,
              item_id,
              session_details?.flow_id,
              session_details?.category_id,
              question.index,
              session_details?.superflow_id,
              session_details?.group_id,
              navigate
            );
          }
        },
        err => {
          console.log(err);
        });
  }

  cleanQuestions(questions: Question[]): any[] {
    const selectedCartItem: any = this.shoppingCartQuery.getActive();
    questions.forEach((question: Question) => {
      // question.question_copy = this.replaceQuestionNumber(question, questions);
      // question.question_copy = this.replaceName(question.question_copy);
      // question.question_prompt = this.replaceName(question.question_prompt);
      // question.question_copy = this.replaceItemNames(question.question_copy, selectedCartItem?.description, question.product_class_id);
      // question.question_prompt = this.replaceItemNames(question.question_prompt, selectedCartItem?.description, question.product_class_id);
      question.question_copy = this.replaceRx(question, questions);
    });
    return questions;
  }

  replaceName(copy: string): any {
    const currentUser: any = this.userStore.getValue();
    if (!copy) {
      return '';
    }
    return copy.replace(/NAME/g, `${currentUser?.first_name} ${currentUser?.last_name}`).replace(/[\[\]']+/g, '');
  }

  replaceRx(question: Question, questions: Question[]): any {
    const q83 = questions.find((q: Question) => q.cent_aq_question_id === 83);
    if (question.cent_aq_question_type_id === QuestionType.radio_column_parent && question.question_copy.includes('Rx')) {
      const value = parseFloat(q83?.answer) * 0.33;
      return question.question_copy.replace(/Rx/g, `<br>${this.accounting.formatMoney(value?.toString())}`);
    }
    return question.question_copy;
  }

  replaceItemNames(copy: string, item_description, class_id: number): any {
    if (item_description) {
      const splittedDescription = item_description?.split('|');

      switch (class_id) {
        case Classes.vehicle:
          return copy.replace(/Car Make/g, splittedDescription[1]?.split(' ')[1]);
        case Classes.watercraft:
          return copy.replace(/Watercraft Item/g, splittedDescription[1]);
        case Classes.personal_item:
          return copy.replace(/Personal Item Name/g, splittedDescription[1]);
        case Classes.building:
          return copy.replace(/Building Address/g, splittedDescription[1]);
        case Classes.content:
          return copy.replace(/Contents Address/g, splittedDescription[1]);
        default:
          return copy;
      }
    } else {
      return copy;
    }
  }

  replaceQuestionNumber(question: Question, questions: Question[]): string {
    let question_copy = question.question_copy;
    const replacementQuestionNumber = this.questionNumberRegex(question);
    if (replacementQuestionNumber > 0) {
      const responseQuestion = questions.find((check: Question) => check.cent_aq_question_id === replacementQuestionNumber);

      if (responseQuestion?.answer !== undefined && responseQuestion.answer !== null) {
        /*if (responseQuestion.answer !== '' && responseQuestion.answer !== undefined) {*/
        let replacement = '';
        const pageQuestions = this.pageQuestions(responseQuestion.page, questions);
        if (pageQuestions?.length > 1) {
          const answers: string[] = [];
          pageQuestions.forEach((q: Question) => {
            answers.push(q.answer);
          });
          replacement = answers.join(' ');
        } else {
          replacement = responseQuestion.answer;
        }
        question_copy = question.question_copy.replace(/[0-9]+/, replacement).replace(/[\[\]']+/g, '');
        /*}*/
      }
    }
    return question_copy;
  }

  updateSuperflowStore(flowItem: FlowItem): any {
    const superflow: any = this.superflowQuery.getValue();
    if (superflow) {
      const superflowItems: FlowItem[] = [];
      superflow?.flow_items?.forEach((f: FlowItem) => {
        const flowItemCopy = Object.assign({}, f);
        if (!superflowItems.some(g => g.flow_id === flowItemCopy.flow_id)) {
          superflowItems.push(flowItemCopy);
        }
      });

      if (superflowItems) {
        const flowItemIndex = superflowItems.findIndex((fi: FlowItem) => fi.flow_id === flowItem.flow_id);
        if (flowItemIndex === -1) {
          superflowItems.push(flowItem);
        } else {
          superflowItems[flowItemIndex] = flowItem;
        }
        this.superflowStore.update({
          flow_items: superflowItems
        });
      }
    }
  }

  loadNextSuperflow(session_id: any, superflow_id: any): any {
    return this.flowPlayer.getNextSuperFlow(session_id, superflow_id)
      .subscribe((superflows: any[]) => {
        if (!superflows?.length) {
          return;
        }

        const super_flow_id = superflows[0]?.next_superflow;
        const category_id = superflows[0]?.category_id;
        const css = superflows[0]?.css;
        if (!super_flow_id) {
          return;
          // NB, we need to know what to do next here
        } else {
          this.flowPlayer.startSuperFlow(super_flow_id, category_id, 0, 0, '0', session_id, css, false);
        }

      });
  }

  loadNextFlow(session_id: any, superflow_id: any, flowId: any, categoryId: any, group_id: any, item_id: any, question: Question, navigate: string = ''): any {

    const flowItem: FlowItem = {
      flow_id: flowId,
      questions: this.questionQuery.getAll()
    };
    this.updateSuperflowStore(flowItem);
    return this.flowPlayer.getNextFlow(session_id, superflow_id, flowId)
      .subscribe((mini_flow: any[]) => {
        if (!mini_flow?.length) {
          return;
        }

        if (!mini_flow[0]?.next) {
          this.loadNextSuperflow(session_id, superflow_id);
        } else {
          
          const person = this.userStore.getValue();
          this.getPersonCategories(person.person_id)
            .subscribe((categories: any[]) => {
              const category = categories.find((cat: any) => cat.product_category_id === +categoryId);
              const css = category?.css;
              if (mini_flow[0]?.item_id) item_id = mini_flow[0]?.item_id;
              this.questionFlowSessionStore.update({item_id: item_id, css});
              return this.flowPlayer.flowQuestions(mini_flow[0]?.next, categoryId, session_id, group_id, item_id,null,0,question?.location_id)
                .subscribe((val: any[]) => {
                  if (!val) {
                    return;
                  } else {
                    const firstQuestion = val.find((q: Question) => q.flow_index === 1);
                    if (firstQuestion) {
                      this.setShoppingCart(firstQuestion, mini_flow[0]?.item_id)
                        .add((sub: any) => {
                          val = this.cleanQuestions(val);
                          this.questionStore.set(val);
                          this.saveFlowHistory(session_id, question.flow_id, question.item_id, question.cent_aq_question_id, firstQuestion.cent_aq_question_id, question.product_class_id).subscribe((response: any) => {
                          });
                          this.questionStore.setActive(firstQuestion.cent_aq_question_id);
                          this.questionFlowSessionStore.update({
                            flow_id: mini_flow[0]?.next
                          });
                          if (navigate?.length > 0) {
                            this.router.navigate([`/${navigate}`]);
                          }
                        });
                    }
                  }
                });

            });
        }


      });
  }

  getMiniFlowNext(question: Question, session_id: any, item_id: any, flowId: any, categoryId: any, index: any, superflow_id: any, group_id: any): any {
    let retrieved = false;
    if (question.conditions?.length === 0 || question.next === null) {

      if (question.next === null) {
        this.setShoppingCart(question, item_id);
        return null;
      } else {
        return this.getMiniQuestion(question.next)
          .subscribe((q: any) => {
            if (!q) {
              return;
            }
            if (q[0] !== undefined) {
              if (retrieved === true) {
                return;
              } else {
                const question_id = q[0].cent_aq_question_id;
                this.flowPlayer.flowQuestions(flowId, categoryId, session_id, group_id, item_id)
                  .subscribe((val: any) => {
                    if (!val) {
                      return;
                    }
                    retrieved = true;
                    this.setShoppingCart(q[0], item_id);
                    val = this.cleanQuestions(val);
                    this.miniQuestionStore.set(val);
                    this.miniQuestionStore.setActive(question_id);
                    this.saveFlowHistory(session_id, question.flow_id, question.item_id, question.cent_aq_question_id, question_id, question.product_class_id).subscribe((response: any) => {
                    });
                  });
              }
            }

          });
      }

    } else {
      return this.getNextQuestion(question, session_id, item_id, flowId, index) // Sam
        .subscribe((val: any) => {
          if (!val) {
            return;
          }
          if (val[0] !== undefined) {
            if (val[0].next == null) {
              return;
            } else {
              const next_question_id = val[0].next;
              this.flowPlayer.flowQuestions(flowId, categoryId, session_id, group_id, item_id)
                .subscribe((v: any) => {
                  if (!v) {
                    return;
                  }
                  this.setShoppingCart(v[0], item_id);
                  v = this.cleanQuestions(v);
                  this.miniQuestionStore.set(v);
                  this.miniQuestionStore.setActive(next_question_id);
                  //this.spinner(false);
                  this.spinnerTransparent(false);
                });
            }
          }
        });
    }
  }

  getNext(question: Question, session_id: any, item_id: any, flowId: any, categoryId: any, index: any, superflow_id: any, group_id: any, navigate: string = ''): any {
    let retrieved = false;
    if (!categoryId) categoryId = question?.category_id;
    if ((!question?.conditions || !question?.conditions?.length) && !question?.next) {
      
      return this.loadNextFlow(session_id, superflow_id, flowId, categoryId, group_id, item_id, question, navigate);

    } else {
      if ((!question?.conditions || !question?.conditions?.length) && question?.next) {
        
        return this.getQuestion(question.next)
          .subscribe((q: any[]) => {
            if (!q?.length) {
              return;
            }
            if (q[0]) {
              if (retrieved === true) {
                return;
              } else {
                const question_id = q[0]?.cent_aq_question_id;
               
                if (question_id) {
                  this.flowPlayer.flowQuestions(flowId, categoryId, session_id, group_id, item_id,null,null, question?.location_id)
                    .subscribe((val: any[]) => {
                      if (!val?.length) {
                        return;
                      }
                      retrieved = true;
                      this.setShoppingCart(q[0], item_id);
                      val = this.cleanQuestions(val);
                      this.questionStore.set(val);
                      this.questionStore.setActive(question_id);
                      this.saveFlowHistory(session_id, question.flow_id, question.item_id, question.cent_aq_question_id, question_id, question.product_class_id).subscribe((response: any) => {
                      });
                      if (navigate?.length > 0) {
                        this.router.navigate([`/${navigate}`]);
                      }
                    });
                }
              }
            }

          });
      }
      else {
        
        return this.getNextQuestion(question, session_id, item_id, flowId, index) // Sam
          .subscribe((val: any[]) => {
            if (!val?.length) {
              return;
            }
            if (val[0]) {
              if (!val[0].next) {
                this.loadNextFlow(session_id, superflow_id, flowId, categoryId, group_id, item_id, question, navigate);
              } else {
                const next_question_id = val[0].next;
                this.flowPlayer.flowQuestions(flowId, categoryId, session_id, group_id, item_id)
                  .subscribe((v: any) => {
                    if (!v) {
                      return;
                    }
                    this.setShoppingCart(v[0], item_id);
                    v = this.cleanQuestions(v);
                    this.questionStore.set(v);
                    this.questionStore.setActive(next_question_id);
                    if (navigate?.length > 0) {
                      this.router.navigate([`/${navigate}`]);
                    }
                  });
              }
            }
          });
      }
    }
  }

  pageQuestions(page: number, questions: Question[]): Question[] {
    return questions.filter((question: Question) => question.page === page && question.answer !== undefined && question.answer !== null && question.answer !== '');
  }

  setShoppingCart(question?: Question, item_id?: string): any {
    const applyShoppingCart = (shoppingCartItems: ShoppingCartItem[]) => {
      shoppingCartItems = shoppingCartItems ?? [];
      let activeCartItem = 0;

      if (question?.product_class_id > 0 && item_id && item_id !== '0') {
        const selectedCartItem = shoppingCartItems.find((cartItem: ShoppingCartItem) => cartItem.class_id === question.product_class_id && cartItem.item_id === item_id);
        if (selectedCartItem) {
          activeCartItem = selectedCartItem.shoppingcart_id;
        }
      }
      this.shoppingCartStore.set(shoppingCartItems);
      if (activeCartItem > 0) {
        this.shoppingCartStore.setActive(activeCartItem);
      }
    };

    return this.getShoppingCart((question?.cent_aq_question_id ? question?.cent_aq_question_id : 0), 'question-flow', (this.currency?.frequency_id ? this.currency?.frequency_id : 0), question?.product_id ? question?.product_id : 0)
      .subscribe({
        next: applyShoppingCart,
        error: (err) => {
          // A session with nothing in it yet 404s instead of returning an empty list — treat that as an empty cart.
          if (err?.status === 404) {
            applyShoppingCart([]);
          } else {
            console.error('setShoppingCart failed', err);
          }
        }
      });
  }

  questionNumberRegex(question: Question): number {
    if (question.cent_aq_question_id !== 66) {
      return 0;
    }
    const regex = new RegExp('[0-9]+');
    const questionNumber = regex.exec(question.question_copy);
    if (questionNumber) {
      return +questionNumber[0];
    } else {
      return 0;
    }
  }

  getPreviousQuestion(question: Question): void {
    this.questionQuery.selectAll({
      limitTo: 1,
      filterBy: [
        entity => entity.page === question.page - 1 && entity.answer !== undefined && entity.answer !== null
      ]
    }).subscribe(val => {
      if (!val?.length) {
        return;
      }
      if (val[0]?.cent_aq_question_id !== undefined) {
        this.questionStore.setActive(val[0]?.cent_aq_question_id);
      }
    });
  }

  getIndexData(index: number, dataset: any[]): any[] {
    const data = [];
    if (dataset?.length) {
      for (const d of dataset) {
        if (d.index === index) {
          data.push(d);
        }
      }
    }
    return data;
  }

  getCount(classId: number, collations: QuoteCollation[]): number {
    let x = 0;
    for (const c of collations) {
      if (c.class_id === classId && c.entry_type === 'item') {
        x++;
      }
    }
    return x;
  }

  getCurrencyFrequency(group_id: number): any {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('group_id', group_id?.toString());
    parameters.set('session_id', session_details.session_id?.toString());
    this.runCommandNew(`getCurrencyFrequency`, parameters).subscribe(result => {
      this.currency = result[0];
      accounting.settings = {
        currency: {
          symbol: this.currency.symbol, // default currency symbol is '$'
          format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
          decimal: '.', // decimal point separator
          thousand: ' ', // thousands separator
          precision: 0, // decimal places
        },
        number: {
          precision: 0, // default precision on numbers is 0
          thousand: ' ',
          decimal: '.',
        }
      };
      this.accounting = accounting;
    });
  }

  setSelectedItem(item: any): void {
    this.selectedItem = item;
    $('#remove-modal').modal('show');
  }

  setSelectedCoverItem(item: any): void {
    this.spinner(true);
    this.selectedCoverItem = item;
    let question: any = this.questionQuery.getActive();
    const session_details = this.questionFlowSessionQuery.getValue();
    //console.log(question,this.selectedCoverItem, session_details);
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details.session_id);
    parameters.set('class_id', this.selectedCoverItem.class_id);
    parameters.set('product_id', question.product_id);
    this.runCommandNew('removeCoverWarning', parameters)
      .subscribe((result: any) => {
        if (result[0].warning_text != ''){
          $('#remove-alert-modal-content').html(result[0].warning_text);
          $('#remove-alert-modal').modal('show');
          this.spinner(false);
        }
        else{
          this.removeSelectedCoverItem();
        }
        
      });
    
  }

  

  setSelectedMiniFlowItem(class_id: any, item_id: any): void {
    this.selectedMiniFlowItem = {class_id, item_id};
    $('#remove-miniflowitem-modal').modal('show');
  }

  removeMiniFlowItem(): void {
    //this.spinner(true);
    this.spinnerTransparent(true);
    const session_details = this.miniFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details.session_id);
    parameters.set('product_class_id', this.selectedMiniFlowItem.class_id);
    const item_id = this.selectedMiniFlowItem?.item_id || this.selectedMiniFlowItem?.session_item_id;
    parameters.set('item_id', item_id);

    let premiums = this.selectedMiniFlowItem?.premiums;
    this.runCommandNew('removeItem', parameters)
      .subscribe((result: any) => {
        if (!result) {
          return;
        }
        if (premiums?.length) {
          premiums = premiums.filter((premium: any) => premium?.item_id !== item_id);
        }
        this.miniFlowPlayerService.passUpdateRequest({action: 'remove', premiums});
        this.setShoppingCart(null, item_id);
        setTimeout(() => {
          //this.spinner(false);
          this.spinnerTransparent(false);
        }, 1000);
      });
  }

  removeItem(): void {
    //this.spinner(true);
    this.spinnerTransparent(true);
    const session_details = this.questionFlowSessionQuery.getValue();
    const item_id = this.selectedItem.item_id || this.selectedItem.session_item_id;
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('product_class_id', `${this.selectedItem.class_id}`);
    parameters.set('item_id', `${item_id}`);
    this.runCommandNew('removeItem', parameters).subscribe(result => {
      this.summaryDataSubject.next(true);
      setTimeout(() => {
        //this.spinner(false);
        this.spinnerTransparent(false);
        // window.location.reload();
      }, 1000);
    });
  }
  removeSelectedCoverItem(): void {
    this.spinner(true);
    const session_details = this.questionFlowSessionQuery.getValue();
    let question: any = this.questionQuery.getActive();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details.session_id);
    parameters.set('class_id', this.selectedCoverItem.class_id);
    parameters.set('product_id', question.product_id);
    this.runCommandNew('removeDependantClasses', parameters)
      .subscribe((result: any) => {
        //this.spinner(false);
        this.flowPlayer.flowQuestions(session_details?.flow_id, session_details?.category_id, session_details?.session_id, session_details?.group_id, question?.item_id)
          .subscribe((v: any) => {
            if (!v) {
              return;
            }
            this.setShoppingCart(question, (question?.item_id ? question?.item_id : '0') === '0' ? (session_details?.item_id ? session_details?.item_id : '0') : question?.item_id)
              .add((sub: any) => {
                this.questionStore.set(v);
                this.questionStore.setActive(question.cent_aq_question_id);
                window.location.reload();
              });
          });
        //this.questionStore.setActive(question.question_id);
      });
  }

  setSummaryDataObservable(value: boolean): void {
    this.summaryDataSubject.next(value);
  }

  initPopoverCustomize(): void {
    const hoverOrFocus = matchMedia('(pointer:fine)').matches ? 'hover' : 'focus';

    // standard popover
    $('.popover-trigger--std[data-toggle="popover"]:not(.popover-trigger--close)').popover({
      template: '<div class="popover" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });

    // wording popover
    $('.popover-trigger--wording[data-toggle="popover"]:not(.popover-trigger--close)').popover({
      template: '<div class="popover popover--wording" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div><div class="popover-close"><img src="assets/icn/close-medium.svg" class="icon" /></div></div>'
    });

    // standard popover with close btn
    $('.popover-trigger--std.popover-trigger--close[data-toggle="popover"]').popover({
      template: '<div class="popover" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div><div class="popover-close"><img src="assets/icn/close-medium.svg" class="icon" /></div></div>'
    });

    // wording popover with close btn
    $('.popover-trigger--wording.popover-trigger--close[data-toggle="popover"]').popover({
      template: '<div class="popover popover--wording" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div><div class="popover-close"><img src="assets/icn/close-medium.svg" class="icon" /></div></div>'
    });

    // small popover
    $('.popover-trigger--sm[data-toggle="popover"]:not(.popover-trigger--hover)').popover({
      template: '<div class="popover popover--sm" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });

    // small popover (hover on non-touch devices)
    $('.popover-trigger--sm.popover-trigger--hover[data-toggle="popover"]').popover({
      template: '<div class="popover popover--sm" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
      trigger: hoverOrFocus,
      boundary: hoverOrFocus === 'hover' ? 'window' : 'scrollParent'
    });


    // special pill hover effect
    $('.pill .popover-trigger')
      .on('shown.bs.popover', function() {
        $(this).closest('.pill').addClass('is-hover');
      })
      .on('hidden.bs.popover', function() {
        $(this).closest('.pill').removeClass('is-hover');
      });

    // prevent any controls from being activated when popover clicked
    $('.popover-trigger').on('click', e => {
      e.stopPropagation();
      e.preventDefault();
    });
  }

  getPageInfo(page: string): void {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details.session_id);
    parameters.set('category_id', session_details.category_id);
    parameters.set('product_group_id', session_details.group_id);
    parameters.set('page', page);
    parameters.set('referer_id', '1');
    parameters.set('broker_user_id', this.person?.person_id.toString());
    parameters.set('broker_id', this.person?.broker_id.toString());
    if (this.storageService.get('partner_code', 'flow') && this.storageService.get('partner_code', 'flow') !== '') {
      parameters.set('partner_code', this.storageService.get('partner_code', 'flow'));
    }

    this.runCommandNew('getPageInfo', parameters)
      .subscribe(info => {
        this.pageInfoSubject.next(info);
      });
  }

  getSecurityCode(): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details.session_id);

    return this.runCommandNew('getSecurityCode', parameters);
  }

  getClaimsSuperflow(policy_id: string, class_id: number, item_id: number, vaps_id: number, person_id: number = 0): Observable<any> {
    const parameters = new Map<string, string>();
    parameters.set('policy_id', policy_id);
    parameters.set('class_id', class_id.toString());
    parameters.set('item_id', item_id.toString());
    parameters.set('vaps_id', vaps_id.toString());
    parameters.set('person_id', person_id.toString());

    return this.runCommandNew('getClaimsSuperflow', parameters);
  }

  cancelClaim(sessionId: string): Observable<any> {
    const parameters = new Map<string, string>();
    parameters.set('session_id', sessionId);
    return this.runCommandNew('cancelClaim', parameters);
  }

  getSection(section: string, entry_type: string): PageInfo {
    const pageInfo = this.pageInfoSubject?.getValue();
    if (pageInfo?.length) {
      return pageInfo?.find(info => info?.section === section && info?.entry_type === entry_type);
    }
    return null;
  }

  getPageSections(section: string, entry_type: string): PageInfo[] {
    const pageInfo = this.pageInfoSubject?.getValue();
    if (pageInfo?.length) {
      return pageInfo?.filter(info => info?.section === section && info?.entry_type === entry_type);
    }
    return [];
  }

  processTpq(): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    return this.runCommandNew('api.tpq_process_all', parameters);
  }

  checkTpqStatus(): Observable<TpqStatusCheck[]> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('use_product_selected ', '1');

    return this.runCommandNew('api.tpq_product_status_check', parameters);
  }

  tpqNotify(): Observable<TpqStatusCheck[]> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);

    return this.runCommandNew('tpq_notify_when_done', parameters);
  }
  goBack(): void {
    let url = this.storageService.get('previous-document-page', 'flow');
    if (url) {
      this.router.navigate([url]);
    }
    else {
      this.router.navigate(['/everything.policy-resources']);
    }

  }
  pdf(html: string, file: string = '', email: boolean = false, person_id: number = 0, emailaddress: string = '', css: string = 'print',bundle = 'bundle', statement: boolean = false): Observable<any> {
    const requestBody = html;
    let env = environment.cssURL;
    if (file !== '')
      return this.httpClient.post(`https://vader.everything.insure/pdf/?f=${file}`, requestBody);
    else
      return this.httpClient.post(`https://vader.everything.insure/pdf/?&email=${email}&person_id=${person_id}&env=${env}&emailaddress=${emailaddress}&css=${css}&bundle=${bundle}&statement=${statement}`, requestBody);

  }
  setPushToken(): void {
    let token = this.storageService.get('push_token', 'user');
    let device = this.storageService.getJson('device', 'user');
    this.person = this.userStore.getValue();
    if (device?.platform && device.platform !== "web" && this.person?.person_id !== 0) {
      const parameters = new Map<string, string>();
      parameters.set('person_id', this.person?.person_id.toString());
      parameters.set('device', device?.platform);
      parameters.set('token', token);
      this.runCommandNew(`setPushToken`, parameters)
        .subscribe(result => {
          // console.log(result)
        }, err => {
          console.error('Registration error: ', err.error);
        });
    }

  }
  // The details a flow creates its quote with. Evi replays them when one of its own sessions
  // needs a quote, so that quote carries the same partner and broker details as the flow's.
  setQuoteParameters(parameters: Map<string, string>): void {
    this.storageService.setJson('quoteParameters', Array.from(parameters), 'flow');
  }
  getQuoteParameters(): Map<string, string> | null {
    const saved = this.storageService.getJson<[string, string][]>('quoteParameters', 'flow');
    return Array.isArray(saved) ? new Map(saved) : null;
  }
  logIP(session_id: string) {
    // Skipped on localhost.
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (isLocal) return of(null);
    let path = `${environment.cssURL}central${this.router.url}`;
    let url = "";
    // if (path.indexOf('dev') > -1) url = `https://vader.everything.insure/ip/dev/?url=${path}&session_id=${session_id}`;
    // else if (path.indexOf('uat')  > -1) url = `https://vader.everything.insure/ip/uat/?url=${path}&session_id=${session_id}`;
    // else if (path.indexOf('staging')  < -1) url = `https://vader.everything.insure/ip/staging/?url=${path}&session_id=${session_id}`;
    //else url = `https://vader.everything.insure/ip/?url="${path}&session_id=${session_id}`;
    url = `https://vader.everything.insure/ip/go/?url=${path}&session_id=${session_id}`;
    // rawHttp, so the interceptor's Authorization header is not sent: that header forces a CORS
    // preflight, and vader answers OPTIONS with a 404. The service needs no token.
    return this.rawHttp.get(url);
  }
  initPDFStuff(): void {
    const pdfPage = document.querySelector(".page--pdf")
    const computedStyles = getComputedStyle(pdfPage || document.documentElement)

    const fullpageHeight = parseInt(computedStyles.getPropertyValue("--emulateprintheight")) || 1123
    const footerMargin = parseInt(computedStyles.getPropertyValue("--footerMargin")) || 28
    const footerHeight = parseInt(computedStyles.getPropertyValue("--footerHeight")) || 54
    const pageVerticalMargins = parseInt(computedStyles.getPropertyValue("--pageVerticalMargins")) || 50

    const pageHeight = fullpageHeight - pageVerticalMargins * 2
    const footerPadding = footerHeight + footerMargin
    const tableHeightSplitThreshold = 100 // minum height of table after split
    const useAccurateComponentHeightCalcs = false // resource intensive when set to true


    function getEffectiveElementHeight(component){
      const componentComputedStyles = window.getComputedStyle(component) || { marginTop: '0px', marginBottom: '0px' }
      // get top margin height of first child element and bottom margin height of last child element and add to component margin heights
      const firstChildComputedStyles = component.firstElementChild
        ? window.getComputedStyle(component.firstElementChild)
        : { marginTop: '0px' }
      const lastChildComputedStyles = component.lastElementChild
        ? window.getComputedStyle(component.lastElementChild)
        : { marginBottom: '0px' }

      const effectiveTopMargin = Math.max(parseInt(componentComputedStyles.marginTop), parseInt(firstChildComputedStyles.marginTop))
      const effectiveBottomMargin = Math.max(parseInt(componentComputedStyles.marginBottom), parseInt(lastChildComputedStyles.marginBottom))

      return component.offsetHeight + effectiveTopMargin + effectiveBottomMargin
    }
  
  
    function measureWrappedComponentsHeight(components: NodeListOf<Element> | Element[], lastComponentIndex: number) {
      // Convert the NodeList to an array and include every component from the first one through the current one.
      const wrappedComponents = Array.from(components).slice(0, lastComponentIndex + 1) as Element[]
      const firstComponent = wrappedComponents[0] as HTMLElement | undefined

      if (!firstComponent) {
        return 0
      }

      // Create a temporary element that will contain the components while they are measured together.
      const wrapper = document.createElement("div")

      // Preserve the original component width so text wraps at the same width during measurement.
      const componentWidth = firstComponent.getBoundingClientRect().width

      // Configure the wrapper to be measurable without changing the visible page layout.
      wrapper.style.cssText = `      
        position: absolute;
        top: 0;
        left: 0;      
        width: ${componentWidth}px;
        height: auto;
        margin: 0;
        padding: 0;
        border: 0;
        overflow: hidden;
        visibility: hidden;
      `

      // Insert the wrapper where the first component currently lives in the page.
      firstComponent.before(wrapper)

      try {
        // Move the selected components into the wrapper; append moves existing nodes rather than cloning them.
        wrapper.append(...wrappedComponents)

        // Read the wrapper height after the browser has laid out all components together.
        return wrapper.getBoundingClientRect().height
      } finally {
        // Always restore the components to their original position, even if measurement throws an error.
        wrapper.replaceWith(...wrappedComponents)
      }
    }

    function increasePageHeight(page, componentHeight, availableHeight){
      const numPages = Math.max(2, Math.ceil(componentHeight / availableHeight))

      page.classList.add("pdf-page--pages", "pdf-page--pages-" + numPages)

      return numPages
    }
  
    function checkPageComponentFit(page) {
      // get total height of page components
      const components = page.querySelectorAll(".pdf-page__component")
      let totalComponentsHeight = 0
      let continueElementHeight = page.querySelector(".pdf-page__continued") ? page.querySelector(".pdf-page__continued").offsetHeight : 0

      const availableHeight = pageHeight - continueElementHeight - footerPadding

      // loop through compontents to see if they fit on page
      for (let i = 0; i < components.length; i++) {

        // if component is marked to always start on a new page, split immediately (unless it's the first component on the page anyways)
        if (i > 0 && components[i].getAttribute("data-split") === "page") {
          console.log("Component marked as data-split='page', splitting to new page")
          splitComponentsToNewPage(components, page, i)
          return
        }

        //
        // Calculate component heights:
        //

        let componentHeightIncludingMargins = 0

        if (useAccurateComponentHeightCalcs) {
          // Measure the complete group so nested and collapsing margins are resolved by the browser.
          const measuredComponentsHeight = measureWrappedComponentsHeight(components, i)
          componentHeightIncludingMargins = measuredComponentsHeight - totalComponentsHeight
          totalComponentsHeight = measuredComponentsHeight
        } else {
          // Use the original per-component estimate, including its copy buffer.
          componentHeightIncludingMargins = getEffectiveElementHeight(components[i])

          const copyElement = components[i].querySelector(".pdf__copy")
          if (copyElement) componentHeightIncludingMargins += 20

          totalComponentsHeight += componentHeightIncludingMargins
        }
       
  
        // if component is too long to fit on page...
        if (totalComponentsHeight > availableHeight) {
          let usedHeightBeforeCurrent = totalComponentsHeight - componentHeightIncludingMargins
          let availableHeightForCurrent = availableHeight - usedHeightBeforeCurrent
          let shouldUsePageHeightFallback = i === 0
  
          console.log("WARNING: component overflows available page height")
  
          // if the component contains a table
          // let's try and split the table up into multiples tables and insert into new pages
          if (components[i].querySelector(".table-pdf-wrap")) {
            console.log("...attempting to split table into multiple tables")
            let didSplitTable = splitTableToNewPage(components, page, i, componentHeightIncludingMargins, availableHeightForCurrent, shouldUsePageHeightFallback)
            if (didSplitTable) return

          } else if (components[i].querySelector(".pdf__data")) {
            console.log("...attempting to split data into multiple pages")
            let didSplitData = splitDataToNewPage(components, page, i, componentHeightIncludingMargins, availableHeightForCurrent, shouldUsePageHeightFallback)
            if (didSplitData) return
  
          // if the component contains a copy element
          } else if (components[i].querySelector(".pdf__copy")) {
            console.log('...attempting to split copy over multiple pages');
            let didSplitCopy = splitCopyToNewPage(components, page, i, componentHeightIncludingMargins, availableHeightForCurrent, shouldUsePageHeightFallback);
            if (didSplitCopy) return
  
            // if the component contains an index list
          } else if (components[i].querySelector(".pdf-index")) {
            console.log("...attempting to split index into multiple pages")
            checkIndexPageFit(components[i].querySelector(".pdf-index"))
            return          
  
            // else check how many pages the component would take up and increase height of page accordingly
            // this is just fallback functionality and should hopefully never occur            
          } else if (i === 0) {
            console.log("...fallback to increase page height")
            increasePageHeight(page, componentHeightIncludingMargins, availableHeight)

            // Keep the oversized component on this page and move all following components to a new page.
            if (components.length > 1) {
              const updatedComponentArray = page.querySelectorAll(".pdf-page__component")
              splitComponentsToNewPage(updatedComponentArray, page, i + 1)
            }
            return
          }
  
          // split page at current component when split wasn't possible (or wasn't attempted)
          splitComponentsToNewPage(components, page, i)
          return
        }
      }
    }
  
    function splitComponentsToNewPage(components, page, componentIdx) {
      // create new page & move remaining components to new page
      let newPage = document.createElement("section")
      newPage.classList.add("pdf-page")
  
      // loop through remaining components and add them to new page
      for (let j = componentIdx; j < components.length; j++) {
        newPage.appendChild(components[j])
      }
  
      // add continue header to new page if data-title exists
      let pageTitle = page.getAttribute("data-title")   
      let componentTitle = components[componentIdx]?.getAttribute("data-component-title")
  
      if (pageTitle) {
        newPage.setAttribute("data-title", pageTitle)
        let continuedHeader = document.createElement("div")
        continuedHeader.classList.add("pdf-page__continued")
  
        if (componentTitle) {
          continuedHeader.innerHTML = "<div class='pdf-page__continued-title'><span>" + pageTitle + " &mdash;</span> " + componentTitle + " continued...</div>"
        } else {
          continuedHeader.innerHTML = "<div class='pdf-page__continued-title'>" + pageTitle + " continued...</div>"
        }   
        
        let documentName = document.querySelector('[data-document-name]')?.getAttribute("data-document-name")      
        if(documentName) continuedHeader.innerHTML += "<div class='pdf-page__continued-doc'>" + documentName + "</div>"
  
        newPage.prepend(continuedHeader)
      }
  
      // add footer to new page
      let footer = page.querySelector(".pdf-page__footer").cloneNode(true)
      newPage.appendChild(footer)
  
      page.after(newPage)
  
      // check new page to see if components fit
      checkPageComponentFit(newPage)
    }
  
    function splitCopyToNewPage(components, page, i, componentHeightIncludingMargins, availableHeight, allowPageHeightFallback = true){
      let copy = components[i].querySelector(".pdf__copy");
      let copyHeight = copy.offsetHeight;
      let copyHeightGoal = copyHeight - (componentHeightIncludingMargins - availableHeight);
  
      let copyElements = copy.querySelectorAll(":scope > *");
      let copyElementsToRemove = 0;
      let splitListPlan = null;
      const splitListMarkerAttr = "data-copy-split-list-target";
  
      let splitIsPossible = true;
  
      for (let j = copyElements.length - 1; j >= 0; j--) {
  
        // elementHeight including bottom margin
        let elementHeight = copyElements[j].offsetHeight + parseInt(window.getComputedStyle(copyElements[j]).marginBottom);
        let nextCopyHeight = copyHeight - elementHeight;
  
        // try list block splitting for UL/OL
        let isList = copyElements[j].tagName === "UL" || copyElements[j].tagName === "OL";
  
        if (isList) {
          // support malformed lists that contain direct child UL/OL blocks
          let listItems = copyElements[j].querySelectorAll(":scope > li, :scope > ul, :scope > ol");
          let requiredReduction = copyHeight - copyHeightGoal;
          let listReducedHeight = 0;
          let listItemsToMove = 0;
          const minimumListItemsToMove = 2;
  
          for (let idx = listItems.length - 1; idx >= 0; idx--) {
            let itemHeight = listItems[idx].offsetHeight + parseInt(window.getComputedStyle(listItems[idx]).marginBottom);
            listReducedHeight += itemHeight;
            listItemsToMove++;
  
            if (listReducedHeight >= requiredReduction && listItemsToMove >= minimumListItemsToMove) {
            break;
          }
          }
  
          // keep at least one list item on current page and move at least two to new page
          if (listItemsToMove >= minimumListItemsToMove && listItemsToMove < listItems.length) {
            splitListPlan = { elementIndex: j, itemsToMove: listItemsToMove };
            copyElements[j].setAttribute(splitListMarkerAttr, "1");
            copyElementsToRemove++;
            copyHeight -= listReducedHeight;
            break;
          }

          if (listItemsToMove >= listItems.length) {
            copyHeight = nextCopyHeight;
            copyElementsToRemove++;

            if (copyHeight < copyHeightGoal) {
              break;
            }

            continue;
          }
        }
        
        // if a single top-level element is too tall
        if (!isList && elementHeight > copyHeightGoal) {
          splitIsPossible = false;
          console.log("WARNING: single element is too tall to fit on page");
          break;
        }
  
        copyHeight = nextCopyHeight;
        copyElementsToRemove++;
  
        if (copyHeight < copyHeightGoal) {
          break;
        }
      }
  
      if (splitIsPossible) {
        console.log("SUCCESS: copy split is possible");  
  
        // check if last element left in remaining copy is a heading, 
        // OR check if there's a 1 line orphaned element flagged for splitting
        // if so, increase number of elements to be removed
  
        // repeat until no more headings are removed
        // skip this rule when splitting list items, otherwise the heading above the list can be moved incorrectly
        if (!splitListPlan) {
          let lastElementToRemoveIdx = copyElements.length - (copyElementsToRemove + 1);
  
          while (
            lastElementToRemoveIdx >= 0
            && (
              copyElements[lastElementToRemoveIdx].tagName === "H2"
              || copyElements[lastElementToRemoveIdx].tagName === "H3"
              || copyElements[lastElementToRemoveIdx].tagName === "H4"
              || copyElements[lastElementToRemoveIdx].tagName === "H5"
              || (copyElementsToRemove === 1 && copyElements[copyElements.length - 1].offsetHeight < 30)
            )
          ) {
            copyElementsToRemove++;
            lastElementToRemoveIdx--;
  
            console.log('Heading found as last child in remaining copy OR orphaned 1-liner found, including it in split...');
          }
        }
  
  
        let newCopy = copy.cloneNode(true);
        let newCopyElements = newCopy.querySelectorAll(":scope > *");
  
        // remove elements from start of cloned copy
        for (let k = 0; k < newCopyElements.length - copyElementsToRemove; k++) {        
            newCopyElements[k].remove();        
        }
  
        // remove elements from end of original copy
        for (let j = copyElements.length - copyElementsToRemove; j < copyElements.length; j++) {
          if (splitListPlan && j === splitListPlan.elementIndex) continue;
          copyElements[j].remove();
        }
  
        // split UL/OL items across pages when list split plan exists
        if (splitListPlan) {
          let originalList = copy.querySelector("[" + splitListMarkerAttr + "='1']");
          let newList = newCopy.querySelector("[" + splitListMarkerAttr + "='1']");
  
          if (originalList && newList) {
  
            // cater for direct child list items and nested lists within the split list block
            let originalListItems = originalList.querySelectorAll(":scope > li, :scope > ul, :scope > ol");
            let newListItems = newList.querySelectorAll(":scope > li, :scope > ul, :scope > ol");
  
            for (let j = originalListItems.length - splitListPlan.itemsToMove; j < originalListItems.length; j++) {
              originalListItems[j].remove();
            }
  
            for (let k = 0; k < newListItems.length - splitListPlan.itemsToMove; k++) {
              newListItems[k].remove();
            }
  
            originalList.removeAttribute(splitListMarkerAttr);
            newList.removeAttribute(splitListMarkerAttr);
          }
        }
  
        let newComponent = document.createElement("div");
        newComponent.classList.add("pdf-page__component");
  
        // copy data-component-title attribute to new component if exists
        let componentTitle = components[i].getAttribute("data-component-title");
        if (componentTitle) {
          newComponent.setAttribute("data-component-title", componentTitle)
        }
        newComponent.appendChild(newCopy);
  
        // append it to the page after the original component
        components[i].after(newComponent);
  
        // then split the components to a new page
        let updatedComponentArray = page.querySelectorAll(".pdf-page__component")
        splitComponentsToNewPage(updatedComponentArray, page, i + 1)
        return true
  
      // failed to split copy ...fallback to increase page height instead
      } else {
        if (!allowPageHeightFallback) {
          return false
        }
  
        console.log('%cFAIL: copy split is not possible, fallback to increase page height', 'color: red')
        increasePageHeight(page, componentHeightIncludingMargins, availableHeight)
  
        // if only the single component left on page, don't split to new page, just increase height of current page
        if (components.length === 1) {
          return true
        }
  
        // then split the components to a new page
        let updatedComponentArray = page.querySelectorAll(".pdf-page__component")
        splitComponentsToNewPage(updatedComponentArray, page, i + 1)
        return true
  
      }
    }
  
    function splitTableToNewPage(components, page, i, componentHeightIncludingMargins, availableHeight, allowPageHeightFallback = true) {
      let table = components[i].querySelector(".table-pdf-wrap")
      let rows = table.querySelectorAll(":not(.cell-nested) tr")
  
      // calc goal height of table
      let tableHeight = table.offsetHeight
      let tableHeightGoal = tableHeight - (componentHeightIncludingMargins - availableHeight)
  
      // calc number of rows that need to be removed from bottom of table
      let rowsToRemove = 0
  
      let splitIsPossible = true
  
      for (let j = rows.length - 1; j >= 0; j--) {
        let rowHeight = rows[j].offsetHeight
        tableHeight -= rowHeight
        rowsToRemove++
  
        // 1 single row is too high, we need to fail to fallback
        if (rowHeight > tableHeightGoal) {
          splitIsPossible = false
          console.log("WARNING: single row is too tall to fit on page")
          break
        }
  
        if (tableHeight < tableHeightGoal) {
          break
        }
      }
  
      // if the remaining original table would be too small (e.g. just header rows), abandon the split
      if (splitIsPossible && tableHeight < tableHeightSplitThreshold) {
        splitIsPossible = false
        console.log("WARNING: remaining original table would be under 100px (likely only header rows), abandoning table split")
      }
  
      // If the last row that would remain on the original table is a header row of some desciption,   
      // move it with the split portion so it is not orphaned at the page bottom.
      let splitStartIdx = rows.length - rowsToRemove
      if (splitStartIdx > 0 && rowsToRemove < rows.length) {
        let lastRemainingRow = rows[splitStartIdx - 1]
        if (lastRemainingRow && lastRemainingRow.querySelectorAll("th").length > 0) {
          rowsToRemove++
        }
      }


      // Abandon the split if moving the orphaned header would remove every row from the original table.
      if (splitIsPossible && rowsToRemove >= rows.length) {
        splitIsPossible = false
        console.log("WARNING: table split would remove all rows from original table, abandoning table split")
      }
  
  
  
      if (splitIsPossible) {
        console.log("SUCCESS: table split is possible")
  
        // create a new table with the rows that need to be removed
        let newTable = table.cloneNode(true)
        let newTableRows = newTable.querySelectorAll("tr")
        let keepFirstRowAsHeader = newTableRows.length > 0 && newTableRows[0].querySelectorAll("th").length > 0
  
        // remove rows from start of cloned table
        for (let k = 0; k < newTableRows.length - rowsToRemove; k++) {
          // leave first row in new table only when it is a header row
          if (!keepFirstRowAsHeader || k > 0) {
            // console.log('removed: '+k +' from clone')
            newTableRows[k].remove()
          }
        }
  
        // remove rows from end of original table & add is-continued class
        table.classList.add("is-continued")
        for (let j = rows.length - rowsToRemove; j < rows.length; j++) {
          // console.log('removed: '+j+ ' from original')
          rows[j].remove()
        }
  
        // create new component element with new table
        let newComponent = document.createElement("div")
        newComponent.classList.add("pdf-page__component")
  
        // copy data-component-title attribute to new component if exists
        let componentTitle = components[i].getAttribute("data-component-title")
        if (componentTitle) {
          newComponent.setAttribute("data-component-title", componentTitle)
        }
        newComponent.appendChild(newTable)
  
        // append it to the page after the original component
        components[i].after(newComponent)
  
        // then split the components to a new page
        let updatedComponentArray = page.querySelectorAll(".pdf-page__component")
        splitComponentsToNewPage(updatedComponentArray, page, i + 1)
        return true
  
        // failed to split table ...fallback to increase page height instead
      } else {
        if (!allowPageHeightFallback) {
          return false
        }
  
        console.log('%cFAIL: table split is not possible, fallback to increase page height', 'color: red')
        increasePageHeight(page, componentHeightIncludingMargins, availableHeight)
  
        // if only the single component left on page, don't split to new page, just increase height of current page
        if (components.length === 1) {
          return true
        }
  
        // then split the components to a new page
        let updatedComponentArray = page.querySelectorAll(".pdf-page__component")
        splitComponentsToNewPage(updatedComponentArray, page, i + 1)
        return true
      }
    }

    function splitDataToNewPage(components, page, i, componentHeightIncludingMargins, availableHeight, allowPageHeightFallback = true) {
      let data = components[i].querySelector(".pdf__data")
      let rows = data.querySelectorAll(".data__row")

      let dataHeight = data.offsetHeight
      let dataHeightGoal = dataHeight - (componentHeightIncludingMargins - availableHeight)
      let rowsToRemove = 0
      let splitIsPossible = rows.length > 1

      for (let j = rows.length - 1; j >= 0 && splitIsPossible; j--) {
        let rowHeight = rows[j].offsetHeight
        dataHeight -= rowHeight
        rowsToRemove++

        if (rowHeight > dataHeightGoal) {
          splitIsPossible = false
          console.log("WARNING: single data row is too high to fit on page")
          break
        }

        if (dataHeight < dataHeightGoal) {
          break
        }
      }

      if (splitIsPossible && (rowsToRemove === 0 || rowsToRemove >= rows.length)) {
        splitIsPossible = false
        console.log("WARNING: data block cannot be split while keeping a row on the current page")
      }

      if (splitIsPossible) {
        console.log("SUCCESS: data split is possible")

        let newData = data.cloneNode(true)
        let newDataRows = newData.querySelectorAll(".data__row")
        let newDataTitle = newData.querySelector(".pdf__data-title")
        let newDataTitleHeading = newDataTitle?.querySelector("h4") || newDataTitle
        if (newDataTitleHeading) newDataTitleHeading.innerHTML += " &mdash; continued..."

        for (let k = 0; k < newDataRows.length - rowsToRemove; k++) {
          newDataRows[k].remove()
        }

        for (let j = rows.length - rowsToRemove; j < rows.length; j++) {
          rows[j].remove()
        }

        let newComponent = document.createElement("div")
        newComponent.classList.add("pdf-page__component")

        let componentTitle = components[i].getAttribute("data-component-title")
        if (componentTitle) {
          newComponent.setAttribute("data-component-title", componentTitle)
        }
        newComponent.appendChild(newData)

        components[i].after(newComponent)

        let updatedComponentArray = page.querySelectorAll(".pdf-page__component")
        splitComponentsToNewPage(updatedComponentArray, page, i + 1)
        return true

      } else {
        if (!allowPageHeightFallback) {
          return false
        }

        console.log('%cFAIL: data split is not possible, fallback to increase page height', 'color: red')
        increasePageHeight(page, componentHeightIncludingMargins, availableHeight)

        if (components.length === 1) {
          return true
        }

        let updatedComponentArray = page.querySelectorAll(".pdf-page__component")
        splitComponentsToNewPage(updatedComponentArray, page, i + 1)
        return true
      }
    }
  
    function splitIndexPage(page, indexList, indexListHeightGoal) {
      let indexListItems = indexList.querySelectorAll("li.pdf-list__item")
      let indexListHeight = indexList.offsetHeight
  
      // calc number of items that need to be removed from bottom of list
      let itemsToRemove = 0
  
      for (let i = indexListItems.length - 1; i >= 0; i--) {
        let itemHeight = indexListItems[i].offsetHeight
        indexListHeight -= itemHeight
        itemsToRemove++
  
        if (indexListHeight < indexListHeightGoal) {
          break
        }
      }
  
      // create a new index list with the items that need to be removed
      let newIndexList = indexList.cloneNode(true)
      let newIndexListItems = newIndexList.querySelectorAll("li.pdf-list__item")
  
      // remove items from start of cloned list
      for (let j = 0; j < newIndexListItems.length - itemsToRemove; j++) {
        newIndexListItems[j].remove()
      }
  
      // remove items from end of original list
      for (let k = indexListItems.length - itemsToRemove; k < indexListItems.length; k++) {
        indexListItems[k].remove()
      }
  
      // create new component element with new index list
      let newComponent = document.createElement("div")
      newComponent.classList.add("pdf-page__component")
  
      let newIndexListWrap = document.createElement("div")
      newIndexListWrap.classList.add("pdf__index")
      newIndexListWrap.appendChild(newIndexList)
      newComponent.appendChild(newIndexListWrap)
  
      // append it to the page after the original component
      page.querySelector(".pdf-page__component").after(newComponent)
  
      // then split the components to a new page
      let updatedComponentArray = page.querySelectorAll(".pdf-page__component")
      splitComponentsToNewPage(updatedComponentArray, page, 1)
    }
  
    function checkIndexPageFit(indexList) {
      if (indexList === null) return
  
      let page = indexList.closest(".pdf-page")
      let indexListHeight = indexList.offsetHeight
      let headerElementHeight = page.querySelector(".pdf__coverhead").offsetHeight || 0
      let pdfIndexMarginTop = parseInt(window.getComputedStyle(page.querySelector('.pdf__index')).marginTop) || 0 
      let indexListHeightGoal = pageHeight - footerPadding - headerElementHeight - pdfIndexMarginTop
  
      if (indexListHeight > indexListHeightGoal) {
        console.log("WARNING: index page is too long, splitting into multiple pages")
        splitIndexPage(page, indexList, indexListHeightGoal)
      }
    }
  
    function addPageNumbersAndIndex(pages) {
      let previousTitle = ""
      let previousSubTitle = ""
  
      if (document.querySelector(".pdf-index") === null) return
  
      pages.forEach((page, index) => {
        // filter only pages with unique data-title attribute
        // and populate index
        let pageTitle = page.getAttribute("data-title")
        let pageTitleId = page.getAttribute("id")
        if (pageTitle && pageTitle !== previousTitle) {
          //
          // build top level index list
          //
          let pageList = document.querySelector(".pdf-index")
          let pageListItem = document.createElement("li")
          pageListItem.classList.add("pdf-list__item")
          let pageTitleAnchor = pageTitleId
            ? "#" + pageTitleId
            : "#anchor-" + pageTitle.toLowerCase().replace(/ /g, '-')
          pageListItem.innerHTML = `<div><p><a href="${pageTitleAnchor}">${pageTitle}</a></p><div><span class="pdf-page-index"></span><a href="${pageTitleAnchor}"><svg class="icon"><use xlink:href="#arrow-right-small"></use></svg></a></div></div>`
          pageList.appendChild(pageListItem)
          previousTitle = pageTitle
  
          //
          // build sublist index list
          //
  
          // find all pages that have the same data-title attribute as current page
          let pagesWithSameTitle = document.querySelectorAll(`.pdf-page[data-title="${pageTitle}"]`)
  
          // prepare a sublist wrapper
          let subList = document.createElement("ul")
  
          // find all instances of .pdf-page__component[data-sub-title] within pages with same title
          pagesWithSameTitle.forEach((pageWithSameTitle, index) => {
            let pageSubTitles = pageWithSameTitle.querySelectorAll(".pdf-page__component[data-sub-title]")
  
            // if there are subtitles, add items to the sublist
            if (pageSubTitles.length > 0) {
              pageSubTitles.forEach((subTitle, index) => {
                let subTitleId = subTitle.getAttribute("id")
                let subTitleAnchor = "#" + subTitleId
                let subTitleText = subTitle.getAttribute("data-sub-title")
                let subListItem = document.createElement("li")
                subListItem.classList.add("pdf-list__subitem")
                subListItem.innerHTML = `<div><p><a href="${subTitleAnchor}">${subTitleText}</a></p><div><span class="pdf-page-index"></span><a href="${subTitleAnchor}"><svg class="icon"><use xlink:href="#arrow-right-small"></use></svg></a></div></div>`
                subList.appendChild(subListItem)
              })
            }
          })
  
          // finally, append the subList created above
          if (subList.children.length > 0) pageListItem.appendChild(subList)
        }
      })
  
      // now we need to check if the index page itself is too long
      // if so, we need to split it into multiple pages
      checkIndexPageFit(document.querySelector(".pdf-index"))
  
      let allIndexListItems = document.querySelectorAll(".pdf-index li.pdf-list__item")
      let uniqueIndexItemCount = 0
      previousTitle = ""
  
      // then we gotta loop through the updated page list and add page numbers and index numbers
      const updatedPages = document.querySelectorAll(".pdf-page:not(.d-none)")
      const pageNumberStart = 1
      updatedPages.forEach((page, index) => {
        // insert page numbers of into .pdf-page-num elements
        let pageNum = index + pageNumberStart
        let pageNumberElements = page.querySelectorAll(".pdf-page-num")
        pageNumberElements.forEach((pageNumberElement, index) => {
          let pageNumString = pageNum < 10 ? "0" + pageNum : pageNum.toString()
          pageNumberElement.innerHTML = pageNumString
        })
  
        // filter only pages with unique data-title attribute
        // and add page numbers
        let pageTitle = page.getAttribute("data-title")
        if (pageTitle && pageTitle !== previousTitle) {
          let pageIndex = index + pageNumberStart
          let pageIndexString = pageIndex < 10 ? "0" + pageIndex : pageIndex.toString()
          allIndexListItems[uniqueIndexItemCount].querySelector(".pdf-page-index").innerHTML = pageIndexString
          previousTitle = pageTitle
          uniqueIndexItemCount += 1
        }
      })
  
      // add sub-level index numbers
      let allSubLevelIndexListItems = document.querySelectorAll(".pdf-index li.pdf-list__subitem")
  
      allSubLevelIndexListItems.forEach((subItem, index) => {
        let anchor = subItem.querySelector("a").getAttribute("href").replace("#", "")
        let anchorEl = document.getElementById(anchor)
        if (anchorEl === null) return
        let pageWithAnchor = anchorEl.closest(".pdf-page")
        let subIndexPageNum = parseInt(pageWithAnchor.querySelector(".pdf-page-num").innerHTML)
        let subIndexString = subIndexPageNum < 10 ? "0" + subIndexPageNum : subIndexPageNum.toString()
        subItem.querySelector(".pdf-page-index").innerHTML = subIndexString
      })
  
      // loop through all the pages again after page numbers have been allocated and update page references
      updatedPages.forEach((page, index) => {
        // find all .pdf-page-x class elements on each page and populate with page number
        let pageRefElements = page.querySelectorAll(".pdf-page-x")
        if (!pageRefElements) return
  
        pageRefElements.forEach((pageRefElement, index) => {
          let pageRefElementTarget = pageRefElement.getAttribute("data-target")
  
          // find page number that contains target element
          let targetTitleEl = document.getElementById(pageRefElementTarget)
          if (!targetTitleEl) return
          let targetPage = targetTitleEl.closest(".pdf-page")
  
          // find page number element within target page
          let targetPageNum = targetPage.querySelector(".pdf-page-num").innerHTML
  
          // update page reference element with page number
          pageRefElement.innerHTML = targetPageNum
        })
      })
  
      // handle anchor clicks
      document.querySelectorAll(".pdf-index a, [data-anchor-scroll]").forEach((anchor) => {
        anchor.addEventListener("click", function (e) {
          e.preventDefault()
          let target = document.querySelector(this.getAttribute("href"))
          if (!target) return

          // create new element within target and scroll to that instead
          let scrollTarget = document.createElement("div")
          scrollTarget.classList.add("pdf-page__scroll-target")
          target.prepend(scrollTarget)
  
          scrollTarget.scrollIntoView({
            behavior: "smooth",
          })
  
          // remove the scroll target after 1 second
          setTimeout(() => {
            scrollTarget.remove()
          }, 1000)
        })
      })
    }
  
    function splitTableRows(table, row, rowHeightMax) {
      const splittableCell = row.querySelector(".cell-legal, .cell-description")
      const cellItems = Array.from(splittableCell?.children || []) as Element[]
      if (cellItems.length === 0) return

      const originalRowHeight = row.offsetHeight
      let itemsToMove = 0
      let remainingCellHeight = splittableCell.offsetHeight

      while (remainingCellHeight > rowHeightMax && itemsToMove < cellItems.length) {
        const item = cellItems[cellItems.length - 1 - itemsToMove]
        remainingCellHeight -= (item as HTMLElement).offsetHeight
        itemsToMove += 1
      }

      // Only cells with multiple direct children can be split
      // A whole direct child cannot be split by this function.
      if (itemsToMove === 0 || itemsToMove === cellItems.length) return

      const rowClone = row.cloneNode(true)
      const cloneCell = rowClone.querySelector(".cell-legal, .cell-description")
      const cloneItems = Array.from(cloneCell.children) as Element[]

      // Remove items that will be moved to the new row
      cloneItems
        .slice(0, cloneItems.length - itemsToMove)
        .forEach((item) => item.remove())

      // Do not repeat the values in the cloned row
      rowClone.querySelectorAll(".cell-legal-num, .cell-value").forEach((cell) => {
        cell.replaceChildren()
      })

      row.after(rowClone)

      if (rowClone.offsetHeight >= originalRowHeight) {
        rowClone.remove()
        return
      }

      cellItems
        .slice(-itemsToMove)
        .forEach((item) => item.remove())

      if (rowClone.offsetHeight > rowHeightMax) {
        splitTableRows(table, rowClone, rowHeightMax)
      }
    }
    
    function checkTableRowsFit(tables) {
      const rowHeightMax = pageHeight - footerPadding - 185 // available page space less page and table headings

      // with each table
      tables.forEach((table, index) => {
        let rows = table.querySelectorAll("tr")

        // check if any rows are higher than rowHeightMax   
        rows.forEach((row, index) => {
          if (row.offsetHeight > rowHeightMax) {
            console.log("WARNING: table row is too high, splitting cell elements...")
            splitTableRows(table, row, rowHeightMax)
          }
        })
      })
    }

    // before the standard row splitting logic, we check to see if there are any 
    // eligable table cells with content that's too tall for a page
    // only specified tables with qualifying cells can be split: 'cell-legal', '.cell-description'
    let splittableTables = document.querySelectorAll(".table--pdf-legal, .table--pdf-splittable")
    checkTableRowsFit(splittableTables)
  
    let pages = document.querySelectorAll(".pdf-page:not(.pdf-page--cover)")
    pages.forEach((page, index) => {
      checkPageComponentFit(page)
    })

    const allCountedPages = document.querySelectorAll(".pdf-page:not(.d-none)")
    addPageNumbersAndIndex(allCountedPages)
  }

  private hideHeadlessOverlays(): void {
    document.querySelectorAll<HTMLElement>(
      '.loader--fs, .loader--absolute, app-evi, .evi, .evi-backdrop, #emergency-services-modal'
    ).forEach(el => el.style.display = 'none');
    document.querySelectorAll<HTMLElement>('[id*="tawk"]').forEach(el => el.style.display = 'none');
  }

  initHeadlessPDF(): void {
    this.hideHeadlessOverlays();
    const firstPdfPage = document.querySelector<HTMLElement>('.pdf-page');
    if (firstPdfPage) firstPdfPage.style.breakBefore = 'auto';
    requestAnimationFrame(() => requestAnimationFrame(() => {
      document.body.dataset['pdfReady'] = 'true';
    }));
  }

  // The counterpart to the pdfReady flag above: a page that cannot render (bad parameters, a
  // failed data load) says so, and the pdf-service fails the request straight away instead of
  // waiting out its time budget for a ready flag that will never come. No-op outside a
  // headless capture.
  failHeadlessPDF(reason: string): void {
    if (new URLSearchParams(window.location.search).get('headless') !== 'true') return;
    document.body.dataset['pdfError'] = reason;
  }

  // cssHref lets callers with their own print stylesheet (e.g. claim-transcript's
  // print_pdf_v2.css) reuse this flow — default matches the plain policy/quote docs.
  // extraParams carries any identifier the pdf-service's Request/buildURL doesn't have
  // a named field for (e.g. period_no, begin_date/end_date, version_id_1/version_id_2,
  // item_id) — the Go service passes these straight through onto the target URL.
  generatePDF(opts: PdfGenerateOpts = {}): Observable<void> {
    return new Observable<void>(observer => {
      const params = new URLSearchParams(window.location.search);
      const isHeadless = params.get('headless') === 'true';
      const useSejda = params.get('pdf_engine') === 'sejda';
      const cssHref = opts.cssHref || 'assets/css/print_pdf.css';

      document.body.classList.add('page--pdf');
      document.body.classList.remove('page--pdf-view', 'page--central');

      let flowSub: { unsubscribe(): void } | undefined;

      // Headless mode has nothing to wait on (initHeadlessPDF() just flips DOM state
      // synchronously for the Go service's own screenshot to find), but the interactive
      // path's real work — the /pdf/generate round trip and the preview it opens — is
      // genuinely async. Callers (preparePDF()'s closePDFNav()) treat this observable's
      // completion as "the PDF is ready", so it must not resolve until runPDFFlow's actual
      // async work finishes — resolving immediately here (as this used to) let the caller
      // navigate/reload away while the PDF request was still in flight, aborting the
      // in-progress download before its response was ever used.
      const run = () => {
        if (isHeadless) this.hideHeadlessOverlays();
        flowSub = this.runPDFFlow(isHeadless, useSejda, opts).subscribe({
          next: () => {
            observer.next();
            observer.complete();
          },
          error: (err) => observer.error(err),
        });
      };

      const existingLink = document.querySelector<HTMLLinkElement>(`link[href*="${cssHref}"]`);
      if (existingLink) {
        run();
        return () => flowSub?.unsubscribe();
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      // relative (no leading slash) so it resolves against <base href> — deployed
      // envs serve under /central, and a root-relative path ignores base href
      // entirely, 404ing with no Content-Type and getting rejected as a stylesheet.
      link.href = cssHref;
      link.media = 'all';

      const cleanup = () => {
        link.removeEventListener('load', onLoad);
        link.removeEventListener('error', onError);
      };

      const onLoad = () => {
        cleanup();
        run();
      };

      const onError = () => {
        cleanup();
        this.initPDFStuff();
        if (isHeadless) {
          document.body.dataset['pdfReady'] = 'true';
        }
        observer.next();
        observer.complete();
      };

      link.addEventListener('load', onLoad);
      link.addEventListener('error', onError);
      document.head.appendChild(link);

      return () => {
        cleanup();
        flowSub?.unsubscribe();
      };
    });
  }

  // Waits for every <img> to finish loading (success or failure), including ones whose
  // [src] binding hasn't resolved yet when this is called (e.g. a component whose data
  // arrives via an extra store round-trip after the page's main data fetch) — a plain
  // snapshot-and-wait misses those entirely, since a not-yet-bound image isn't "pending"
  // from the browser's point of view. A MutationObserver picks up src changes and newly
  // added <img> elements for the duration of the wait so those get covered too.
  waitForImagesLoaded(timeoutMs = 8000, quietMs = 400): Promise<void> {
    return new Promise<void>(resolve => {
      const pending = new Set<HTMLImageElement>();
      let settled = false;
      let quietHandle: ReturnType<typeof setTimeout>;

      const finish = () => {
        if (settled) return;
        settled = true;
        observer.disconnect();
        clearTimeout(quietHandle);
        clearTimeout(hardTimeoutHandle);
        resolve();
      };

      // Resolve once nothing has settled or appeared for `quietMs` and nothing is
      // pending — NOT immediately on the first check, which would disconnect the
      // observer before a late [src] binding (e.g. an extra store round-trip after
      // the page's main data fetch) ever gets a chance to start loading.
      const scheduleQuietCheck = () => {
        clearTimeout(quietHandle);
        quietHandle = setTimeout(() => {
          if (pending.size === 0) finish();
        }, quietMs);
      };

      const track = (img: HTMLImageElement) => {
        if (img.complete || pending.has(img)) return;
        pending.add(img);
        const onSettle = () => {
          pending.delete(img);
          scheduleQuietCheck();
        };
        img.addEventListener('load', onSettle, { once: true });
        img.addEventListener('error', onSettle, { once: true });
      };

      const trackWithin = (node: Node) => {
        if (node instanceof HTMLImageElement) track(node);
        else if (node instanceof HTMLElement) node.querySelectorAll('img').forEach(track);
      };

      Array.from(document.images).forEach(track);

      const observer = new MutationObserver(mutations => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.target instanceof HTMLImageElement) {
            track(m.target);
          }
          m.addedNodes.forEach(trackWithin);
        }
        scheduleQuietCheck();
      });
      observer.observe(document.body, {
        attributes: true, attributeFilter: ['src'], childList: true, subtree: true,
      });

      const hardTimeoutHandle = setTimeout(finish, timeoutMs);
      scheduleQuietCheck();
    });
  }

  // Returns an observable that only resolves once its branch's real work is done — the
  // interactive branches genuinely wait on an async HTTP round trip, so a caller chaining
  // off completion (generatePDF()) sees "done" only once the PDF has actually been fetched
  // and previewed (or the request has failed), not as soon as the request was fired off.
  private runPDFFlow(
    isHeadless: boolean,
    useSejda: boolean,
    opts: PdfGenerateOpts
  ): Observable<void> {
    try {
      this.initPDFStuff();
    } catch (e) {
      // pagination/splitting is cosmetic — a DOM-measurement failure here must not
      // block the headless capture signal below, or the Go service times out after
      // 120s with the loader still visible over otherwise-rendered content.
      console.error('initPDFStuff failed, continuing without pagination adjustments', e);
    }
    if (isHeadless) {
      this.initHeadlessPDF();
      this.spinner(false);
      return of(undefined);
    }
    let device: any;
    try { device = this.storageService.getJson('device', 'user'); } catch {}
    const isNative = device?.platform && device.platform !== 'web';

    if (useSejda) {
      this.spinner(true);
      const element = document.getElementById('search-body');
      return this.pdf(element.innerHTML, '', false, 0, '', 'print_pdf_v2', 'app').pipe(
        switchMap((resp: string) => {
          const id = resp.replace('https://vader.everything.insure/pdf/files/', '');
          setTimeout(() => {
            this.pdf('', id).subscribe();
          }, 5000);
          if (isNative) {
            Browser.open({ url: resp.toString() });
            this.spinner(false);
            return of(undefined);
          }
          // fetch as a blob and show it in-page instead of window.open(), which browsers
          // block as a popup this far removed (async HTTP callback) from the user's click
          return this.httpClient.get(resp.toString(), { responseType: 'blob' }).pipe(
            tap((blob) => {
              this.spinner(false);
              this.showPDFPreview(URL.createObjectURL(blob));
            }),
            map(() => undefined)
          );
        }),
        catchError((err) => {
          this.spinner(false);
          return throwError(() => err);
        })
      );
    }
    this.spinner(true);
    // router.url is relative to the app root (base-href already stripped by Angular),
    // e.g. "everything.policy-pdf-schedule" — matches what pdf-service's appURLs
    // base already includes ("/central"). window.location.pathname would still have
    // the "central/" segment in it, doubling up into ".../central/central/...".
    const path = this.router.url.split('?')[0].replace(/^\//, '');
    const goParams: Record<string, string> = { env: this.resolveEnv(), path };
    if (opts.sessionId) goParams['session_id'] = opts.sessionId;
    else if (opts.tokenId) goParams['token_id'] = opts.tokenId;
    else if (opts.policyId) goParams['policy_id'] = opts.policyId;
    if (opts.classId) goParams['class_id'] = opts.classId;
    if (opts.productId) goParams['product_id'] = opts.productId;
    if (opts.documentId) goParams['document_id'] = opts.documentId;
    if (opts.extraParams) Object.assign(goParams, opts.extraParams);
    return this.pdfServiceRequest(goParams).pipe(
      tap((blob) => {
        this.spinner(false);
        const pdfBlob = new Blob([blob], { type: 'application/pdf' });
        const url = URL.createObjectURL(pdfBlob);
        if (isNative) {
          Browser.open({ url });
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        } else {
          this.showPDFPreview(url);
        }
      }),
      map(() => undefined),
      // spinner/error surfacing lives here so both branches behave the same; the actual
      // "PDF generation failed" alert is left to the caller's own error handler (e.g.
      // preparePDF()) so it isn't shown twice.
      catchError((err) => {
        this.spinner(false);
        return throwError(() => err);
      })
    );
  }

  downloadPDF(path: string, opts: { sessionId?: string; policyId?: string; extraParams?: Record<string, string> }): Observable<Blob> {
    const goParams: Record<string, string> = { env: this.resolveEnv(), path };
    if (opts.sessionId) goParams['session_id'] = opts.sessionId;
    else if (opts.policyId) goParams['policy_id'] = opts.policyId;
    if (opts.extraParams) Object.assign(goParams, opts.extraParams);
    return this.pdfServiceRequest(goParams);
  }

  private resolveEnv(): string {
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') return 'local';
    if (h.includes('uat')) return 'uat';
    if (h.includes('staging')) return 'staging';
    if (h.includes('dev')) return 'dev';
    return 'prod';
  }

  // Locally, prefer the local pdf-service (localhost:8090 via the /pdf proxy) so PDF
  // generation reflects uncommitted local changes -- but it's a manually-started process
  // that's easy to forget to run, so fall back to the deployed vader endpoint when it can't be
  // reached. Non-local hosts always go straight to vader.
  // An error the local service itself returned is not a reason to fall back: that would hide
  // the local failure behind a PDF rendered from the deployed dev build. The service marks every
  // response with X-Pdf-Service; the dev-server proxy's own 500 (nothing listening) carries none.
  private pdfServiceRequest(goParams: Record<string, string>): Observable<Blob> {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    // vader is remote and can never reach this machine's own localhost, so 'env=local'
    // (meaningful only to the local pdf-service, which targets this machine directly)
    // 500s there — fall back to 'dev' so vader has a real, reachable env to target.
    const vaderRequest = () => this.rawHttp.get(environment.pdfServiceUrl, {
      responseType: 'blob',
      params: isLocal ? { ...goParams, env: 'dev' } : goParams,
    });
    const request = !isLocal ? vaderRequest() : this.rawHttp
      .get('/pdf/generate', { responseType: 'blob', params: goParams })
      .pipe(catchError((err) => {
        if (err instanceof HttpErrorResponse && err.headers.has('X-Pdf-Service')) {
          return throwError(() => err);
        }
        console.warn('Local pdf-service unavailable — using vader with env=dev, so this PDF is rendered from the deployed dev build.');
        return vaderRequest();
      }));
    // The service gives itself 90s per request and answers inside that, so this only fires
    // when nothing answers at all.
    return request.pipe(timeout(120000));
  }
}
